!(function (t, e) {
  'object' == typeof exports && 'undefined' != typeof module
    ? e(exports)
    : 'function' == typeof define && define.amd
    ? define(['exports'], e)
    : e(((t = 'undefined' != typeof globalThis ? globalThis : t || self).window = t.window || {}));
})(this, function (t) {
  'use strict';
  var e, i, s, n;
  let r = (t) =>
      'object' == typeof t &&
      null !== t &&
      t.constructor === Object &&
      '[object Object]' === Object.prototype.toString.call(t),
    o = (t, ...e) => {
      let i = e.length;
      for (let s = 0; s < i; s++) {
        let n = e[s] || {};
        Object.entries(n).forEach(([e, i]) => {
          let s = Array.isArray(i) ? [] : {};
          t[e] || Object.assign(t, {[e]: s}),
            r(i)
              ? Object.assign(t[e], o(s, i))
              : Array.isArray(i)
              ? Object.assign(t, {[e]: [...i]})
              : Object.assign(t, {[e]: i});
        });
      }
      return t;
    },
    a = function (t, e) {
      let i = !0;
      return (...s) => {
        i &&
          ((i = !1),
          t(...s),
          setTimeout(() => {
            i = !0;
          }, e));
      };
    },
    l = (t, e) => {
      let i = [];
      return (
        t.childNodes.forEach((t) => {
          t.nodeType !== Node.ELEMENT_NODE || (e && !t.matches(e)) || i.push(t);
        }),
        i
      );
    },
    h = function (t) {
      var e = new DOMParser().parseFromString(t, 'text/html').body;
      if (e.childElementCount > 1) {
        for (var i = document.createElement('div'); e.firstChild; ) i.appendChild(e.firstChild);
        return i;
      }
      return e.firstChild;
    },
    c = (t, e = 1e4) => Math.round(((t = parseFloat(t + '') || 0) + Number.EPSILON) * e) / e,
    d = (t) => `${t || ''}`.split(' ').filter((t) => !!t),
    u = (t, e) => {
      t &&
        d(e).forEach((e) => {
          t.classList.add(e);
        });
    },
    g = (t, e) => {
      t &&
        d(e).forEach((e) => {
          t.classList.remove(e);
        });
    },
    f = (t, e, i) => {
      d(e).forEach((e) => {
        t && t.classList.toggle(e, i || !1);
      });
    },
    p =
      '<div class="f-spinner"><svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="20"></circle><circle cx="25" cy="25" r="20"></circle></svg></div>',
    m = function (t, e) {
      return t.split('.').reduce((t, e) => ('object' == typeof t ? t[e] : void 0), e);
    };
  class $ {
    constructor(t = {}) {
      for (let e of (Object.defineProperty(this, 'options', {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t,
      }),
      Object.defineProperty(this, 'events', {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: new Map(),
      }),
      this.setOptions(t),
      Object.getOwnPropertyNames(Object.getPrototypeOf(this))))
        e.startsWith('on') && 'function' == typeof this[e] && (this[e] = this[e].bind(this));
    }
    setOptions(t) {
      for (let [e, i] of ((this.options = t ? o({}, this.constructor.defaults, t) : {}),
      Object.entries(this.option('on') || {})))
        this.on(e, i);
    }
    option(t, ...e) {
      let i = m(t, this.options);
      return i && 'function' == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...s) {
      var n;
      let r = m(e, t);
      'string' != typeof (n = r) || isNaN(n) || isNaN(parseFloat(n)) || (r = parseFloat(r)),
        'true' === r && (r = !0),
        'false' === r && (r = !1),
        r && 'function' == typeof r && (r = r.call(this, this, t, ...s));
      let o = m(e, this.options);
      return (
        o && 'function' == typeof o
          ? (r = o.call(this, this, t, ...s, r))
          : void 0 === r && (r = o),
        void 0 === r ? i : r
      );
    }
    cn(t) {
      let e = this.options.classes;
      return (e && e[t]) || '';
    }
    localize(t, e = []) {
      t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i) => {
        let s = '';
        return (
          i
            ? (s = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`))
            : e && (s = this.option(`l10n.${e}`)),
          s || (s = t),
          s
        );
      });
      for (let i = 0; i < e.length; i++) t = t.split(e[i][0]).join(e[i][1]);
      return (t = t.replace(/\{\{(.*?)\}\}/g, (t, e) => e));
    }
    on(t, e) {
      let i = [];
      'string' == typeof t ? (i = t.split(' ')) : Array.isArray(t) && (i = t),
        this.events || (this.events = new Map()),
        i.forEach((t) => {
          let i = this.events.get(t);
          i || (this.events.set(t, []), (i = [])),
            i.includes(e) || i.push(e),
            this.events.set(t, i);
        });
    }
    off(t, e) {
      let i = [];
      'string' == typeof t ? (i = t.split(' ')) : Array.isArray(t) && (i = t),
        i.forEach((t) => {
          let i = this.events.get(t);
          if (Array.isArray(i)) {
            let s = i.indexOf(e);
            s > -1 && i.splice(s, 1);
          }
        });
    }
    emit(t, ...e) {
      [...(this.events.get(t) || [])].forEach((t) => t(this, ...e)),
        '*' !== t && this.emit('*', t, ...e);
    }
  }
  Object.defineProperty($, 'version', {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: '5.0.14',
  }),
    Object.defineProperty($, 'defaults', {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: {},
    });
  class b extends $ {
    constructor(t = {}) {
      super(t),
        Object.defineProperty(this, 'plugins', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {},
        });
    }
    attachPlugins(t = {}) {
      let e = new Map();
      for (let [i, s] of Object.entries(t)) {
        let n = this.option(i),
          r = this.plugins[i];
        r || !1 === n
          ? r && !1 === n && (r.detach(), delete this.plugins[i])
          : e.set(i, new s(this, n || {}));
      }
      for (let [o, a] of e) (this.plugins[o] = a), a.attach();
      this.emit('attachPlugins');
    }
    detachPlugins() {
      for (let t of Object.values(this.plugins)) t.detach();
      return (this.plugins = {}), this.emit('detachPlugins'), this;
    }
  }
  let v = function (t, e) {
    return (
      !(!t || t === document.body || (e && t === e)) &&
      (!(function (t) {
        if (!(t && t instanceof Element && t.offsetParent)) return !1;
        let e = t.scrollHeight > t.clientHeight,
          i = window.getComputedStyle(t).overflowY,
          s = -1 !== i.indexOf('hidden'),
          n = -1 !== i.indexOf('visible');
        return e && !s && !n;
      })(t)
        ? v(t.parentElement, e)
        : t)
    );
  };
  class y {
    constructor(t) {
      Object.defineProperty(this, 'pageX', {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0,
      }),
        Object.defineProperty(this, 'pageY', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, 'clientX', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, 'clientY', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, 'id', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, 'time', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, 'nativePointer', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        (this.nativePointer = t),
        (this.pageX = t.pageX),
        (this.pageY = t.pageY),
        (this.clientX = t.clientX),
        (this.clientY = t.clientY),
        (this.id = self.Touch && t instanceof Touch ? t.identifier : -1),
        (this.time = Date.now());
    }
  }
  let _ = {passive: !1};
  class x {
    constructor(t, {start: e = () => !0, move: i = () => {}, end: s = () => {}}) {
      for (let n of (Object.defineProperty(this, 'element', {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0,
      }),
      Object.defineProperty(this, 'startCallback', {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0,
      }),
      Object.defineProperty(this, 'moveCallback', {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0,
      }),
      Object.defineProperty(this, 'endCallback', {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0,
      }),
      Object.defineProperty(this, 'currentPointers', {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: [],
      }),
      Object.defineProperty(this, 'startPointers', {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: [],
      }),
      (this.element = t),
      (this.startCallback = e),
      (this.moveCallback = i),
      (this.endCallback = s),
      ['onPointerStart', 'onTouchStart', 'onMove', 'onTouchEnd', 'onPointerEnd', 'onWindowBlur']))
        this[n] = this[n].bind(this);
      this.element.addEventListener('mousedown', this.onPointerStart, _),
        this.element.addEventListener('touchstart', this.onTouchStart, _),
        this.element.addEventListener('touchmove', this.onMove, _),
        this.element.addEventListener('touchend', this.onTouchEnd),
        this.element.addEventListener('touchcancel', this.onTouchEnd);
    }
    onPointerStart(t) {
      if (!t.buttons || 0 !== t.button) return;
      let e = new y(t);
      this.currentPointers.some((t) => t.id === e.id) ||
        (this.triggerPointerStart(e, t) &&
          (window.addEventListener('mousemove', this.onMove),
          window.addEventListener('mouseup', this.onPointerEnd),
          window.addEventListener('blur', this.onWindowBlur)));
    }
    onTouchStart(t) {
      for (let e of Array.from(t.changedTouches || [])) this.triggerPointerStart(new y(e), t);
      window.addEventListener('blur', this.onWindowBlur);
    }
    onMove(t) {
      let e = this.currentPointers.slice(),
        i =
          'changedTouches' in t
            ? Array.from(t.changedTouches || []).map((t) => new y(t))
            : [new y(t)],
        s = [];
      for (let n of i) {
        let r = this.currentPointers.findIndex((t) => t.id === n.id);
        r < 0 || (s.push(n), (this.currentPointers[r] = n));
      }
      s.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
      (t.buttons > 0 && 0 !== t.button) ||
        (this.triggerPointerEnd(t, new y(t)),
        window.removeEventListener('mousemove', this.onMove),
        window.removeEventListener('mouseup', this.onPointerEnd),
        window.removeEventListener('blur', this.onWindowBlur));
    }
    onTouchEnd(t) {
      for (let e of Array.from(t.changedTouches || [])) this.triggerPointerEnd(t, new y(e));
    }
    triggerPointerStart(t, e) {
      return (
        !!this.startCallback(e, t, this.currentPointers.slice()) &&
        (this.currentPointers.push(t), this.startPointers.push(t), !0)
      );
    }
    triggerPointerEnd(t, e) {
      let i = this.currentPointers.findIndex((t) => t.id === e.id);
      i < 0 ||
        (this.currentPointers.splice(i, 1),
        this.startPointers.splice(i, 1),
        this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
      this.clear();
    }
    clear() {
      for (; this.currentPointers.length; ) {
        let t = this.currentPointers[this.currentPointers.length - 1];
        this.currentPointers.splice(this.currentPointers.length - 1, 1),
          this.startPointers.splice(this.currentPointers.length - 1, 1),
          this.endCallback(
            new Event('touchend', {
              bubbles: !0,
              cancelable: !0,
              clientX: t.clientX,
              clientY: t.clientY,
            }),
            t,
            this.currentPointers.slice()
          );
      }
    }
    stop() {
      this.element.removeEventListener('mousedown', this.onPointerStart, _),
        this.element.removeEventListener('touchstart', this.onTouchStart, _),
        this.element.removeEventListener('touchmove', this.onMove, _),
        this.element.removeEventListener('touchend', this.onTouchEnd),
        this.element.removeEventListener('touchcancel', this.onTouchEnd),
        window.removeEventListener('mousemove', this.onMove),
        window.removeEventListener('mouseup', this.onPointerEnd),
        window.removeEventListener('blur', this.onWindowBlur);
    }
  }
  function P(t, e) {
    return e
      ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2))
      : 0;
  }
  function w(t, e) {
    return e ? {clientX: (t.clientX + e.clientX) / 2, clientY: (t.clientY + e.clientY) / 2} : t;
  }
  ((s = e || (e = {}))[(s.Init = 0)] = 'Init'),
    (s[(s.Error = 1)] = 'Error'),
    (s[(s.Ready = 2)] = 'Ready'),
    (s[(s.Panning = 3)] = 'Panning'),
    (s[(s.Mousemove = 4)] = 'Mousemove'),
    (s[(s.Destroy = 5)] = 'Destroy');
  let S = ['a', 'b', 'c', 'd', 'e', 'f'],
    T = (t) => t && null !== t && t instanceof Element && 'nodeType' in t,
    E = {a: 1, b: 0, c: 0, d: 1, e: 0, f: 0},
    z = 'mousemove',
    k = 'drag',
    C = 'content',
    R = null,
    A = null;
  class L extends b {
    get isTouchDevice() {
      return null === A && (A = window.matchMedia('(hover: none)').matches), A;
    }
    get isMobile() {
      return null === R && (R = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), R;
    }
    get panMode() {
      return this.options.panMode !== z || this.isTouchDevice ? k : z;
    }
    get panOnlyZoomed() {
      let t = this.options.panOnlyZoomed;
      return 'auto' === t ? this.isTouchDevice : t;
    }
    get isInfinite() {
      return this.option('infinite');
    }
    get angle() {
      return (180 * Math.atan2(this.current.b, this.current.a)) / Math.PI || 0;
    }
    get targetAngle() {
      return (180 * Math.atan2(this.target.b, this.target.a)) / Math.PI || 0;
    }
    get scale() {
      let {a: t, b: e} = this.current;
      return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
      let {a: t, b: e} = this.target;
      return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
      return this.option('minScale') || 1;
    }
    get fullScale() {
      let {contentRect: t} = this;
      return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
      return this.fullScale * (this.option('maxScale') || 1) || 1;
    }
    get coverScale() {
      let {containerRect: t, contentRect: e} = this,
        i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
      return Math.min(this.fullScale, i);
    }
    get isScaling() {
      return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
      let t = this.content;
      return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
      if (this.isBouncingX || this.isBouncingY) return !1;
      for (let t of S) {
        let e = 'e' == t || 'f' === t ? 0.001 : 1e-5;
        if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
      }
      return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, i = {}, s = {}) {
      var n;
      if (
        (super(i),
        Object.defineProperty(this, 'pointerTracker', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'resizeObserver', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'updateTimer', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'clickTimer', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'rAF', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'isTicking', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, 'friction', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, 'ignoreBounds', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, 'isBouncingX', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, 'isBouncingY', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, 'clicks', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, 'trackingPoints', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: [],
        }),
        Object.defineProperty(this, 'pwt', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, 'cwd', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, 'pmme', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, 'state', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: e.Init,
        }),
        Object.defineProperty(this, 'isDragging', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, 'container', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, 'content', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, 'spinner', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'containerRect', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {width: 0, height: 0, innerWidth: 0, innerHeight: 0},
        }),
        Object.defineProperty(this, 'contentRect', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            fullWidth: 0,
            fullHeight: 0,
            fitWidth: 0,
            fitHeight: 0,
            width: 0,
            height: 0,
          },
        }),
        Object.defineProperty(this, 'dragStart', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {x: 0, y: 0, top: 0, left: 0, time: 0},
        }),
        Object.defineProperty(this, 'dragOffset', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {x: 0, y: 0, time: 0},
        }),
        Object.defineProperty(this, 'current', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: Object.assign({}, E),
        }),
        Object.defineProperty(this, 'target', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: Object.assign({}, E),
        }),
        Object.defineProperty(this, 'velocity', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {a: 0, b: 0, c: 0, d: 0, e: 0, f: 0},
        }),
        Object.defineProperty(this, 'lockedAxis', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        !t)
      )
        throw Error('Container Element Not Found');
      (this.container = t),
        this.initContent(),
        this.attachPlugins(Object.assign(Object.assign({}, L.Plugins), s)),
        this.emit('init');
      let r = this.content;
      if (
        (r.addEventListener('load', this.onLoad),
        r.addEventListener('error', this.onError),
        this.isContentLoading)
      ) {
        if (this.option('spinner')) {
          t.classList.add(this.cn('isLoading'));
          let o = h(p);
          !t.contains(r) || r.parentElement instanceof HTMLPictureElement
            ? (this.spinner = t.appendChild(o))
            : (this.spinner =
                (null === (n = r.parentElement) || void 0 === n ? void 0 : n.insertBefore(o, r)) ||
                null);
        }
        this.emit('beforeLoad');
      } else
        queueMicrotask(() => {
          this.enable();
        });
    }
    initContent() {
      let {container: t} = this,
        e = this.cn(C),
        i = this.option(C) || t.querySelector(`.${e}`);
      if (
        (i || ((i = t.querySelector('img,picture') || t.firstElementChild) && u(i, e)),
        i instanceof HTMLPictureElement && (i = i.querySelector('img')),
        !i)
      )
        throw Error('No content found');
      this.content = i;
    }
    onLoad() {
      this.spinner && (this.spinner.remove(), (this.spinner = null)),
        this.option('spinner') && this.container.classList.remove(this.cn('isLoading')),
        this.emit('afterLoad'),
        this.state === e.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
      this.state !== e.Destroy &&
        (this.spinner && (this.spinner.remove(), (this.spinner = null)),
        this.stop(),
        this.detachEvents(),
        (this.state = e.Error),
        this.emit('error'));
    }
    attachObserver() {
      var t;
      let e = () =>
        Math.abs(this.containerRect.width - this.container.getBoundingClientRect().width) > 0.1 ||
        Math.abs(this.containerRect.height - this.container.getBoundingClientRect().height) > 0.1;
      this.resizeObserver ||
        void 0 === window.ResizeObserver ||
        (this.resizeObserver = new ResizeObserver(() => {
          this.updateTimer ||
            (e()
              ? (this.onResize(),
                this.isMobile &&
                  (this.updateTimer = setTimeout(() => {
                    e() && this.onResize(), (this.updateTimer = null);
                  }, 500)))
              : this.updateTimer && (clearTimeout(this.updateTimer), (this.updateTimer = null)));
        })),
        null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
      var t;
      null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
      let {container: t} = this;
      t.addEventListener('click', this.onClick, {passive: !1, capture: !1}),
        t.addEventListener('wheel', this.onWheel, {passive: !1}),
        (this.pointerTracker = new x(t, {
          start: this.onPointerDown,
          move: this.onPointerMove,
          end: this.onPointerUp,
        })),
        document.addEventListener(z, this.onMouseMove);
    }
    detachEvents() {
      var t;
      let {container: e} = this;
      e.removeEventListener('click', this.onClick, {passive: !1, capture: !1}),
        e.removeEventListener('wheel', this.onWheel, {passive: !1}),
        null === (t = this.pointerTracker) || void 0 === t || t.stop(),
        (this.pointerTracker = null),
        document.removeEventListener(z, this.onMouseMove),
        document.removeEventListener('keydown', this.onKeydown, !0),
        this.clickTimer && (clearTimeout(this.clickTimer), (this.clickTimer = null)),
        this.updateTimer && (clearTimeout(this.updateTimer), (this.updateTimer = null));
    }
    animate() {
      let t = this.friction;
      this.setTargetForce();
      let e = this.option('maxVelocity');
      for (let i of S)
        t
          ? ((this.velocity[i] *= 1 - t),
            e &&
              !this.isScaling &&
              (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)),
            (this.current[i] += this.velocity[i]))
          : (this.current[i] = this.target[i]);
      this.setTransform(),
        this.setEdgeForce(),
        !this.isResting || this.isDragging
          ? (this.rAF = requestAnimationFrame(() => this.animate()))
          : this.stop('current');
    }
    setTargetForce() {
      for (let t of S)
        ('e' === t && this.isBouncingX) ||
          ('f' === t && this.isBouncingY) ||
          (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
      let {current: i} = this,
        s = i.e + t,
        n = i.f + e,
        r = this.getBounds(),
        {x: o, y: a} = r,
        l = o.min,
        h = o.max,
        c = a.min,
        d = a.max,
        u = 0,
        g = 0;
      return (
        l !== 1 / 0 && s < l ? (u = l - s) : h !== 1 / 0 && s > h && (u = h - s),
        c !== 1 / 0 && n < c ? (g = c - n) : d !== 1 / 0 && n > d && (g = d - n),
        0.001 > Math.abs(u) && (u = 0),
        0.001 > Math.abs(g) && (g = 0),
        Object.assign(Object.assign({}, r), {xDiff: u, yDiff: g, inBounds: !u && !g})
      );
    }
    clampTargetBounds() {
      let {target: t} = this,
        {x: e, y: i} = this.getBounds();
      e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)),
        e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)),
        i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)),
        i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
      let {content: e, contentRect: i} = this,
        {fitWidth: s, fitHeight: n, fullWidth: r, fullHeight: o} = i,
        a = r,
        l = o;
      if (this.option('zoom') || 0 !== this.angle) {
        let h =
            !(e instanceof HTMLImageElement) &&
            ('none' === window.getComputedStyle(e).maxWidth ||
              'none' === window.getComputedStyle(e).maxHeight),
          c = h ? r : s,
          d = h ? o : n,
          u = this.getMatrix(t),
          g = new DOMPoint(0, 0).matrixTransform(u),
          f = new DOMPoint(0 + c, 0).matrixTransform(u),
          p = new DOMPoint(0 + c, 0 + d).matrixTransform(u),
          m = new DOMPoint(0, 0 + d).matrixTransform(u),
          $ = Math.abs(p.x - g.x),
          b = Math.abs(p.y - g.y),
          v = Math.abs(m.x - f.x),
          y = Math.abs(m.y - f.y);
        (a = Math.max($, v)), (l = Math.max(b, y));
      }
      return {contentWidth: a, contentHeight: l};
    }
    setEdgeForce() {
      if (
        this.ignoreBounds ||
        this.isDragging ||
        this.panMode === z ||
        this.targetScale < this.scale
      )
        return (this.isBouncingX = !1), void (this.isBouncingY = !1);
      let {target: t} = this,
        {x: e, y: i, xDiff: s, yDiff: n} = this.checkBounds(),
        r = this.option('maxVelocity'),
        o = this.velocity.e,
        a = this.velocity.f;
      0 !== s
        ? ((this.isBouncingX = !0),
          s * o <= 0
            ? (o += 0.14 * s)
            : ((o = 0.14 * s),
              e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)),
              e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))),
          r && (o = Math.max(Math.min(o, r), -1 * r)))
        : (this.isBouncingX = !1),
        0 !== n
          ? ((this.isBouncingY = !0),
            n * a <= 0
              ? (a += 0.14 * n)
              : ((a = 0.14 * n),
                i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)),
                i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))),
            r && (a = Math.max(Math.min(a, r), -1 * r)))
          : (this.isBouncingY = !1),
        this.isBouncingX && (this.velocity.e = o),
        this.isBouncingY && (this.velocity.f = a);
    }
    enable() {
      let {content: t} = this,
        i = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
      for (let s of S) this.current[s] = this.target[s] = i[s];
      this.updateMetrics(),
        this.attachObserver(),
        this.attachEvents(),
        (this.state = e.Ready),
        this.emit('ready');
    }
    onClick(t) {
      var e;
      this.isDragging &&
        (null === (e = this.pointerTracker) || void 0 === e || e.clear(),
        (this.trackingPoints = []),
        this.startDecelAnim());
      let i = t.target;
      if (!i || t.defaultPrevented) return;
      if (i && i.hasAttribute('disabled')) return t.preventDefault(), void t.stopPropagation();
      if (
        (() => {
          let t = window.getSelection();
          return t && 'Range' === t.type;
        })() &&
        !i.closest('button')
      )
        return;
      let s = i.closest('[data-panzoom-action]'),
        n = i.closest('[data-panzoom-change]'),
        r = s || n,
        o = r && T(r) ? r.dataset : null;
      if (o) {
        let a = o.panzoomChange,
          l = o.panzoomAction;
        if (((a || l) && t.preventDefault(), a)) {
          let h = {};
          try {
            h = JSON.parse(a);
          } catch (c) {
            console && console.warn('The given data was not valid JSON');
          }
          return void this.applyChange(h);
        }
        if (l) return void (this[l] && this[l]());
      }
      if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3)
        return t.preventDefault(), void t.stopPropagation();
      let d = this.content.getBoundingClientRect();
      if (
        this.dragStart.time &&
        !this.canZoomOut() &&
        (Math.abs(d.x - this.dragStart.x) > 2 || Math.abs(d.y - this.dragStart.y) > 2)
      )
        return;
      this.dragStart.time = 0;
      let u = (e) => {
          this.option('zoom') &&
            e &&
            'string' == typeof e &&
            /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) &&
            'function' == typeof this[e] &&
            (t.preventDefault(), this[e]({event: t}));
        },
        g = this.option('click', t),
        f = this.option('dblClick', t);
      f
        ? (this.clicks++,
          1 == this.clicks &&
            (this.clickTimer = setTimeout(() => {
              1 === this.clicks
                ? (this.emit('click', t), !t.defaultPrevented && g && u(g))
                : (this.emit('dblClick', t), t.defaultPrevented || u(f)),
                (this.clicks = 0),
                (this.clickTimer = null);
            }, 350)))
        : (this.emit('click', t), !t.defaultPrevented && g && u(g));
    }
    addTrackingPoint(t) {
      let e = this.trackingPoints.filter((t) => t.time > Date.now() - 100);
      e.push(t), (this.trackingPoints = e);
    }
    onPointerDown(t, e, i) {
      var s;
      (this.pwt = 0), (this.dragOffset = {x: 0, y: 0, time: 0}), (this.trackingPoints = []);
      let n = this.content.getBoundingClientRect();
      if (
        ((this.dragStart = {x: n.x, y: n.y, top: n.top, left: n.left, time: Date.now()}),
        this.clickTimer)
      )
        return !1;
      if (this.panMode === z && this.targetScale > 1)
        return t.preventDefault(), t.stopPropagation(), !1;
      if (!i.length) {
        let r = t.composedPath()[0];
        if (
          ['A', 'TEXTAREA', 'OPTION', 'INPUT', 'SELECT', 'VIDEO'].includes(r.nodeName) ||
          r.closest('[contenteditable]') ||
          r.closest('[data-selectable]') ||
          r.closest('[data-panzoom-change]') ||
          r.closest('[data-panzoom-action]')
        )
          return !1;
        null === (s = window.getSelection()) || void 0 === s || s.removeAllRanges();
      }
      if ('mousedown' === t.type) t.preventDefault();
      else if (Math.abs(this.velocity.a) > 0.3) return !1;
      return (
        (this.target.e = this.current.e),
        (this.target.f = this.current.f),
        this.stop(),
        this.isDragging ||
          ((this.isDragging = !0), this.addTrackingPoint(e), this.emit('touchStart', t)),
        !0
      );
    }
    onPointerMove(t, e, i) {
      if (
        !1 === this.option('touch', t) ||
        !this.isDragging ||
        (e.length < 2 && this.panOnlyZoomed && c(this.targetScale) <= c(this.minScale)) ||
        (this.emit('touchMove', t), t.defaultPrevented)
      )
        return;
      this.addTrackingPoint(e[0]);
      let {content: s} = this,
        n = w(i[0], i[1]),
        r = w(e[0], e[1]),
        o = 0,
        a = 0;
      if (e.length > 1) {
        let l = s.getBoundingClientRect();
        (o = n.clientX - l.left - 0.5 * l.width), (a = n.clientY - l.top - 0.5 * l.height);
      }
      let h = P(i[0], i[1]),
        d = P(e[0], e[1]),
        u = h ? d / h : 1,
        g = r.clientX - n.clientX,
        f = r.clientY - n.clientY;
      (this.dragOffset.x += g),
        (this.dragOffset.y += f),
        (this.dragOffset.time = Date.now() - this.dragStart.time);
      let p = c(this.targetScale) === c(this.minScale) && this.option('lockAxis');
      if (p && !this.lockedAxis) {
        if ('xy' === p || 'y' === p || 'touchmove' === t.type) {
          if (6 > Math.abs(this.dragOffset.x) && 6 > Math.abs(this.dragOffset.y))
            return void t.preventDefault();
          let m = Math.abs((180 * Math.atan2(this.dragOffset.y, this.dragOffset.x)) / Math.PI);
          (this.lockedAxis = m > 45 && m < 135 ? 'y' : 'x'),
            (this.dragOffset.x = 0),
            (this.dragOffset.y = 0),
            (g = 0),
            (f = 0);
        } else this.lockedAxis = p;
      }
      if (
        (v(t.target, this.content) && ((p = 'x'), (this.dragOffset.y = 0)),
        p && 'xy' !== p && this.lockedAxis !== p && c(this.targetScale) === c(this.minScale))
      )
        return;
      t.cancelable && t.preventDefault(), this.container.classList.add(this.cn('isDragging'));
      let $ = this.checkBounds(g, f);
      this.option('rubberband')
        ? ('x' !== this.isInfinite &&
            (($.xDiff > 0 && g < 0) || ($.xDiff < 0 && g > 0)) &&
            (g *= Math.max(0, 0.5 - Math.abs((0.75 / this.contentRect.fitWidth) * $.xDiff))),
          'y' !== this.isInfinite &&
            (($.yDiff > 0 && f < 0) || ($.yDiff < 0 && f > 0)) &&
            (f *= Math.max(0, 0.5 - Math.abs((0.75 / this.contentRect.fitHeight) * $.yDiff))))
        : ($.xDiff && (g = 0), $.yDiff && (f = 0));
      let b = this.targetScale,
        y = this.minScale,
        _ = this.maxScale;
      b < 0.5 * y && (u = Math.max(u, y)),
        b > 1.5 * _ && (u = Math.min(u, _)),
        'y' === this.lockedAxis && c(b) === c(y) && (g = 0),
        'x' === this.lockedAxis && c(b) === c(y) && (f = 0),
        this.applyChange({
          originX: o,
          originY: a,
          panX: g,
          panY: f,
          scale: u,
          friction: this.option('dragFriction'),
          ignoreBounds: !0,
        });
    }
    onPointerUp(t, i, s) {
      if (s.length)
        return (this.dragOffset.x = 0), (this.dragOffset.y = 0), void (this.trackingPoints = []);
      this.container.classList.remove(this.cn('isDragging')),
        this.isDragging &&
          (this.addTrackingPoint(i),
          this.panOnlyZoomed &&
            this.contentRect.width - this.contentRect.fitWidth < 1 &&
            this.contentRect.height - this.contentRect.fitHeight < 1 &&
            (this.trackingPoints = []),
          v(t.target, this.content) && 'y' === this.lockedAxis && (this.trackingPoints = []),
          this.emit('touchEnd', t),
          (this.isDragging = !1),
          (this.lockedAxis = !1),
          this.state !== e.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
      let t = this.isScaling;
      for (let e of (this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)),
      (this.isBouncingX = !1),
      (this.isBouncingY = !1),
      S))
        this.velocity[e] = 0;
      (this.target.e = this.current.e),
        (this.target.f = this.current.f),
        g(this.container, 'is-scaling'),
        g(this.container, 'is-animating'),
        (this.isTicking = !1);
      let {trackingPoints: i} = this,
        s = i[0],
        n = i[i.length - 1],
        r = 0,
        o = 0,
        a = 0;
      n && s && ((r = n.clientX - s.clientX), (o = n.clientY - s.clientY), (a = n.time - s.time));
      let l = 0,
        h = 0,
        d = 0,
        u = 0,
        f = this.option('decelFriction'),
        p = this.targetScale;
      if (a > 0) {
        (d = Math.abs(r) > 3 ? r / (a / 30) : 0), (u = Math.abs(o) > 3 ? o / (a / 30) : 0);
        let m = this.option('maxVelocity');
        m && ((d = Math.max(Math.min(d, m), -1 * m)), (u = Math.max(Math.min(u, m), -1 * m)));
      }
      d && (l = d / (1 / (1 - f) - 1)),
        u && (h = u / (1 / (1 - f) - 1)),
        ('y' === this.option('lockAxis') ||
          ('xy' === this.option('lockAxis') &&
            'y' === this.lockedAxis &&
            c(p) === this.minScale)) &&
          (l = d = 0),
        ('x' === this.option('lockAxis') ||
          ('xy' === this.option('lockAxis') &&
            'x' === this.lockedAxis &&
            c(p) === this.minScale)) &&
          (h = u = 0);
      let $ = this.dragOffset.x,
        b = this.dragOffset.y,
        v = this.option('dragMinThreshold') || 0;
      Math.abs($) < v && Math.abs(b) < v && ((l = h = 0), (d = u = 0)),
        (p < this.minScale - 1e-5 || p > this.maxScale + 1e-5 || (t && !l && !h)) && (f = 0.35),
        this.applyChange({panX: l, panY: h, friction: f}),
        this.emit('decel', d, u, $, b);
    }
    onWheel(t) {
      var e = [-t.deltaX || 0, -t.deltaY || 0, -t.detail || 0].reduce(function (t, e) {
        return Math.abs(e) > Math.abs(t) ? e : t;
      });
      if (
        (this.emit('wheel', t, Math.max(-1, Math.min(1, e))),
        this.panMode === z || t.defaultPrevented)
      )
        return;
      let i = this.option('wheel');
      'pan' === i
        ? (t.preventDefault(),
          (this.panOnlyZoomed && !this.canZoomOut()) ||
            this.applyChange({panX: -(2 * t.deltaX), panY: -(2 * t.deltaY), bounce: !1}))
        : 'zoom' === i && !1 !== this.option('zoom') && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
      this.panWithMouse(t);
    }
    onKeydown(t) {
      'Escape' === t.key && this.toggleFS();
    }
    onResize() {
      this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
      this.emit('beforeTransform');
      let {current: t, target: e, content: i, contentRect: s} = this,
        n = Object.assign({}, E);
      for (let r of S) {
        let o = 'e' == r || 'f' === r ? 1e3 : 1e5;
        (n[r] = c(t[r], o)),
          Math.abs(e[r] - t[r]) < ('e' == r || 'f' === r ? 0.51 : 0.001) && (t[r] = e[r]);
      }
      let {a: a, b: l, c: h, d: d, e: u, f: g} = n,
        f = `matrix(${a}, ${l}, ${h}, ${d}, ${u}, ${g})`,
        p = i.parentElement instanceof HTMLPictureElement ? i.parentElement : i;
      if ((this.option('transformParent') && (p = p.parentElement || p), p.style.transform === f))
        return;
      p.style.transform = f;
      let {contentWidth: m, contentHeight: $} = this.calculateContentDim();
      (s.width = m), (s.height = $), this.emit('afterTransform');
    }
    updateMetrics(t = !1) {
      var i, s;
      if (!this || this.state === e.Destroy || this.isContentLoading) return;
      let {container: n, content: r} = this,
        o = r instanceof HTMLImageElement,
        a = n.getBoundingClientRect(),
        l = getComputedStyle(this.container),
        h = a.width,
        d = a.height,
        u = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom),
        g = h - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight));
      this.containerRect = {width: h, height: d, innerWidth: g, innerHeight: d - u};
      let f = this.option('width') || 'auto',
        p = this.option('height') || 'auto',
        m,
        $;
      'auto' === f &&
        (f =
          parseFloat(r.dataset.width || '') ||
          (m =
            (i = r) instanceof HTMLImageElement
              ? i.naturalWidth
              : i instanceof SVGElement
              ? i.width.baseVal.value
              : Math.max(i.offsetWidth, i.scrollWidth)) ||
          0),
        'auto' === p &&
          (p =
            parseFloat(r.dataset.height || '') ||
            ($ =
              (s = r) instanceof HTMLImageElement
                ? s.naturalHeight
                : s instanceof SVGElement
                ? s.height.baseVal.value
                : Math.max(s.offsetHeight, s.scrollHeight)) ||
            0);
      let b = r.parentElement instanceof HTMLPictureElement ? r.parentElement : r;
      this.option('transformParent') && (b = b.parentElement || b);
      let v = b.getAttribute('style') || '';
      b.style.setProperty('transform', 'none', 'important'),
        o && ((b.style.width = ''), (b.style.height = '')),
        b.offsetHeight;
      let y = r.getBoundingClientRect(),
        _ = y.width,
        x = y.height,
        P = 0,
        w = 0;
      o &&
        (Math.abs(f - _) > 1 || Math.abs(p - x) > 1) &&
        ({
          width: _,
          height: x,
          top: P,
          left: w,
        } = ((t, e, i, s) => {
          let n = i / s;
          return (
            n > t / e ? ((i = t), (s = t / n)) : ((i = e * n), (s = e)),
            {width: i, height: s, top: 0.5 * (e - s), left: 0.5 * (t - i)}
          );
        })(_, x, f, p)),
        (this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
          top: y.top - a.top + P,
          bottom: a.bottom - y.bottom + P,
          left: y.left - a.left + w,
          right: a.right - y.right + w,
          fitWidth: _,
          fitHeight: x,
          width: _,
          height: x,
          fullWidth: f,
          fullHeight: p,
        })),
        (b.style.cssText = v),
        o && ((b.style.width = `${_}px`), (b.style.height = `${x}px`)),
        this.setTransform(),
        !0 !== t && this.emit('refresh'),
        this.ignoreBounds ||
          (c(this.targetScale) < c(this.minScale)
            ? this.zoomTo(this.minScale, {friction: 0})
            : this.targetScale > this.maxScale
            ? this.zoomTo(this.maxScale, {friction: 0})
            : this.state === e.Init || this.checkBounds().inBounds || this.requestTick()),
        this.updateControls();
    }
    getBounds() {
      let t = this.option('bounds');
      if ('auto' !== t) return t;
      let {contentWidth: e, contentHeight: i} = this.calculateContentDim(this.target),
        s = 0,
        n = 0,
        r = 0,
        o = 0,
        a = this.option('infinite');
      if (!0 === a || (this.lockedAxis && a === this.lockedAxis))
        (s = -1 / 0), (r = 1 / 0), (n = -1 / 0), (o = 1 / 0);
      else {
        let {containerRect: l, contentRect: h} = this,
          d = c(this.contentRect.fitWidth * this.targetScale, 1e3),
          u = c(this.contentRect.fitHeight * this.targetScale, 1e3),
          {innerWidth: g, innerHeight: f} = l;
        if (
          (this.containerRect.width === d && (g = l.width),
          this.containerRect.width === u && (f = l.height),
          e > g)
        ) {
          s = -1 * (r = 0.5 * (e - g));
          let p = 0.5 * (h.right - h.left);
          (s += p), (r += p);
        }
        if (
          (this.contentRect.fitWidth > g &&
            e < g &&
            ((s -= 0.5 * (this.contentRect.fitWidth - g)),
            (r -= 0.5 * (this.contentRect.fitWidth - g))),
          i > f)
        ) {
          n = -1 * (o = 0.5 * (i - f));
          let m = 0.5 * (h.bottom - h.top);
          (n += m), (o += m);
        }
        this.contentRect.fitHeight > f &&
          i < f &&
          ((s -= 0.5 * (this.contentRect.fitHeight - f)),
          (r -= 0.5 * (this.contentRect.fitHeight - f)));
      }
      return {x: {min: s, max: r}, y: {min: n, max: o}};
    }
    updateControls() {
      let t = this.container,
        {
          panMode: e,
          contentRect: i,
          fullScale: s,
          targetScale: n,
          coverScale: r,
          maxScale: o,
          minScale: a,
        } = this,
        l =
          {
            toggleMax: n - a < 0.5 * (o - a) ? o : a,
            toggleCover: n - a < 0.5 * (r - a) ? r : a,
            toggleZoom: n - a < 0.5 * (s - a) ? s : a,
          }[this.option('click') || ''] || a,
        h = this.canZoomIn(),
        d = this.canZoomOut(),
        u = d && e === k;
      c(n) < c(a) && !this.panOnlyZoomed && (u = !0),
        (c(i.width, 1) > c(i.fitWidth, 1) || c(i.height, 1) > c(i.fitHeight, 1)) && (u = !0),
        c(i.width * n, 1) < c(i.fitWidth, 1) && (u = !1),
        e === z && (u = !1);
      let g = h && c(l) > c(n),
        p = !g && !u && d && c(l) < c(n);
      for (let m of (f(t, this.cn('canZoomIn'), g),
      f(t, this.cn('canZoomOut'), p),
      f(t, this.cn('isDraggable'), u),
      t.querySelectorAll('[data-panzoom-action="zoomIn"]')))
        h
          ? (m.removeAttribute('disabled'), m.removeAttribute('tabindex'))
          : (m.setAttribute('disabled', ''), m.setAttribute('tabindex', '-1'));
      for (let $ of t.querySelectorAll('[data-panzoom-action="zoomOut"]'))
        d
          ? ($.removeAttribute('disabled'), $.removeAttribute('tabindex'))
          : ($.setAttribute('disabled', ''), $.setAttribute('tabindex', '-1'));
      for (let b of t.querySelectorAll(
        '[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]'
      )) {
        h || d
          ? (b.removeAttribute('disabled'), b.removeAttribute('tabindex'))
          : (b.setAttribute('disabled', ''), b.setAttribute('tabindex', '-1'));
        let v = b.querySelector('g');
        v && (v.style.display = h ? '' : 'none');
      }
    }
    panTo({
      x: t = this.target.e,
      y: i = this.target.f,
      scale: s = this.targetScale,
      friction: n = this.option('friction'),
      angle: r = 0,
      originX: o = 0,
      originY: a = 0,
      flipX: l = !1,
      flipY: h = !1,
      ignoreBounds: c = !1,
    }) {
      this.state !== e.Destroy &&
        this.applyChange({
          panX: t - this.target.e,
          panY: i - this.target.f,
          scale: s / this.targetScale,
          angle: r,
          originX: o,
          originY: a,
          friction: n,
          flipX: l,
          flipY: h,
          ignoreBounds: c,
        });
    }
    applyChange({
      panX: t = 0,
      panY: i = 0,
      scale: s = 1,
      angle: n = 0,
      originX: r = -this.current.e,
      originY: o = -this.current.f,
      friction: a = this.option('friction'),
      flipX: l = !1,
      flipY: h = !1,
      ignoreBounds: d = !1,
      bounce: u = this.option('bounce'),
    }) {
      if (this.state === e.Destroy) return;
      this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)),
        (this.friction = a || 0),
        (this.ignoreBounds = d);
      let {current: g} = this,
        f = g.e,
        p = g.f,
        m = this.getMatrix(this.target),
        $ = new DOMMatrix().translate(f, p).translate(r, o).translate(t, i);
      if (this.option('zoom')) {
        if (!d) {
          let b = this.targetScale,
            v = this.minScale,
            y = this.maxScale;
          b * s < v && (s = v / b), b * s > y && (s = y / b);
        }
        $ = $.scale(s);
      }
      for (let _ of (($ = $.translate(-r, -o).translate(-f, -p).multiply(m)),
      n && ($ = $.rotate(n)),
      l && ($ = $.scale(-1, 1)),
      h && ($ = $.scale(1, -1)),
      S))
        'e' !== _ && 'f' !== _ && ($[_] > this.minScale + 1e-5 || $[_] < this.minScale - 1e-5)
          ? (this.target[_] = $[_])
          : (this.target[_] = c($[_], 1e3));
      (this.targetScale < this.scale || Math.abs(s - 1) > 0.1 || this.panMode === z || !1 === u) &&
        !d &&
        this.clampTargetBounds(),
        this.isResting || ((this.state = e.Panning), this.requestTick());
    }
    stop(t = !1) {
      if (this.state === e.Init || this.state === e.Destroy) return;
      let i = this.isTicking;
      for (let s of (this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)),
      (this.isBouncingX = !1),
      (this.isBouncingY = !1),
      S))
        (this.velocity[s] = 0),
          'current' === t
            ? (this.current[s] = this.target[s])
            : 'target' === t && (this.target[s] = this.current[s]);
      this.setTransform(),
        g(this.container, 'is-scaling'),
        g(this.container, 'is-animating'),
        (this.isTicking = !1),
        (this.state = e.Ready),
        i && (this.emit('endAnimation'), this.updateControls());
    }
    requestTick() {
      this.isTicking ||
        (this.emit('startAnimation'),
        this.updateControls(),
        u(this.container, 'is-animating'),
        this.isScaling && u(this.container, 'is-scaling')),
        (this.isTicking = !0),
        this.rAF || (this.rAF = requestAnimationFrame(() => this.animate()));
    }
    panWithMouse(t, e = this.option('mouseMoveFriction')) {
      if (((this.pmme = t), this.panMode !== z || !t || c(this.targetScale) <= c(this.minScale)))
        return;
      this.emit('mouseMove', t);
      let {container: i, containerRect: s, contentRect: n} = this,
        r = s.width,
        o = s.height,
        a = i.getBoundingClientRect(),
        l = (t.clientX || 0) - a.left,
        h = (t.clientY || 0) - a.top,
        {contentWidth: d, contentHeight: u} = this.calculateContentDim(this.target),
        g = this.option('mouseMoveFactor');
      g > 1 && (d !== r && (d *= g), u !== o && (u *= g));
      let f = 0.5 * (d - r) - (((l / r) * 100) / 100) * (d - r);
      f += 0.5 * (n.right - n.left);
      let p = 0.5 * (u - o) - (((h / o) * 100) / 100) * (u - o);
      (p += 0.5 * (n.bottom - n.top)),
        this.applyChange({panX: f - this.target.e, panY: p - this.target.f, friction: e});
    }
    zoomWithWheel(t) {
      if (this.state === e.Destroy || this.state === e.Init) return;
      let i = Date.now();
      if (i - this.pwt < 45) return void t.preventDefault();
      this.pwt = i;
      var s = [-t.deltaX || 0, -t.deltaY || 0, -t.detail || 0].reduce(function (t, e) {
        return Math.abs(e) > Math.abs(t) ? e : t;
      });
      let n = Math.max(-1, Math.min(1, s)),
        {targetScale: r, maxScale: o, minScale: a} = this,
        l = (r * (100 + 45 * n)) / 100;
      c(l) < c(a) && c(r) <= c(a)
        ? ((this.cwd += Math.abs(n)), (l = a))
        : c(l) > c(o) && c(r) >= c(o)
        ? ((this.cwd += Math.abs(n)), (l = o))
        : ((this.cwd = 0), (l = Math.max(Math.min(l, o), a))),
        this.cwd > this.option('wheelLimit') ||
          (t.preventDefault(), c(l) !== c(r) && this.zoomTo(l, {event: t}));
    }
    canZoomIn() {
      return (
        this.option('zoom') &&
        (c(this.contentRect.width, 1) < c(this.contentRect.fitWidth, 1) ||
          c(this.targetScale) < c(this.maxScale))
      );
    }
    canZoomOut() {
      return this.option('zoom') && c(this.targetScale) > c(this.minScale);
    }
    zoomIn(t = 1.25, e) {
      this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = 0.8, e) {
      this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
      this.zoomTo('fit', t);
    }
    zoomToCover(t) {
      this.zoomTo('cover', t);
    }
    zoomToFull(t) {
      this.zoomTo('full', t);
    }
    zoomToMax(t) {
      this.zoomTo('max', t);
    }
    toggleZoom(t) {
      this.zoomTo(
        this.targetScale - this.minScale < 0.5 * (this.fullScale - this.minScale) ? 'full' : 'fit',
        t
      );
    }
    toggleMax(t) {
      this.zoomTo(
        this.targetScale - this.minScale < 0.5 * (this.maxScale - this.minScale) ? 'max' : 'fit',
        t
      );
    }
    toggleCover(t) {
      this.zoomTo(
        this.targetScale - this.minScale < 0.5 * (this.coverScale - this.minScale)
          ? 'cover'
          : 'fit',
        t
      );
    }
    iterateZoom(t) {
      this.zoomTo('next', t);
    }
    zoomTo(t = 1, {friction: i = 'auto', originX: s = 0, originY: n = 0, event: r} = {}) {
      if (this.isContentLoading || this.state === e.Destroy) return;
      let {targetScale: o} = this;
      this.stop();
      let a = 1;
      if ((this.panMode === z && (r = this.pmme || r), r)) {
        let l = this.content.getBoundingClientRect(),
          h = r.clientX || 0,
          c = r.clientY || 0;
        (s = h - l.left - 0.5 * l.width), (n = c - l.top - 0.5 * l.height);
      }
      let d = this.fullScale,
        u = this.maxScale,
        g = this.coverScale;
      'number' == typeof t
        ? (a = t / o)
        : ('next' === t &&
            (d - g < 0.2 && (g = d), (t = o < d - 1e-5 ? 'full' : o < u - 1e-5 ? 'max' : 'fit')),
          (a =
            'full' === t
              ? d / o || 1
              : 'cover' === t
              ? g / o || 1
              : 'max' === t
              ? u / o || 1
              : 1 / o || 1)),
        (i = 'auto' === i ? (a > 1 ? 0.15 : 0.25) : i),
        this.applyChange({scale: a, originX: s, originY: n, friction: i}),
        r && this.panMode === z && this.panWithMouse(r, i);
    }
    rotateCCW() {
      this.applyChange({angle: -90});
    }
    rotateCW() {
      this.applyChange({angle: 90});
    }
    flipX() {
      this.applyChange({flipX: !0});
    }
    flipY() {
      this.applyChange({flipY: !0});
    }
    fitX() {
      this.stop('target');
      let {containerRect: t, contentRect: e, target: i} = this;
      this.applyChange({
        panX: 0.5 * t.width - (e.left + 0.5 * e.fitWidth) - i.e,
        panY: 0.5 * t.height - (e.top + 0.5 * e.fitHeight) - i.f,
        scale: t.width / e.fitWidth / this.targetScale,
        originX: 0,
        originY: 0,
        ignoreBounds: !0,
      });
    }
    fitY() {
      this.stop('target');
      let {containerRect: t, contentRect: e, target: i} = this;
      this.applyChange({
        panX: 0.5 * t.width - (e.left + 0.5 * e.fitWidth) - i.e,
        panY: 0.5 * t.innerHeight - (e.top + 0.5 * e.fitHeight) - i.f,
        scale: t.height / e.fitHeight / this.targetScale,
        originX: 0,
        originY: 0,
        ignoreBounds: !0,
      });
    }
    toggleFS() {
      let {container: t} = this,
        e = this.cn('inFullscreen'),
        i = this.cn('htmlHasFullscreen');
      t.classList.toggle(e);
      let s = t.classList.contains(e);
      s
        ? (document.documentElement.classList.add(i),
          document.addEventListener('keydown', this.onKeydown, !0))
        : (document.documentElement.classList.remove(i),
          document.removeEventListener('keydown', this.onKeydown, !0)),
        this.updateMetrics(),
        this.emit(s ? 'enterFS' : 'exitFS');
    }
    getMatrix(t = this.current) {
      let {a: e, b: i, c: s, d: n, e: r, f: o} = t;
      return new DOMMatrix([e, i, s, n, r, o]);
    }
    reset(t) {
      if (this.state !== e.Init && this.state !== e.Destroy) {
        for (let i of (this.stop('current'), S)) this.target[i] = E[i];
        (this.target.a = this.minScale),
          (this.target.d = this.minScale),
          this.clampTargetBounds(),
          this.isResting ||
            ((this.friction = void 0 === t ? this.option('friction') : t),
            (this.state = e.Panning),
            this.requestTick());
      }
    }
    destroy() {
      this.stop(), (this.state = e.Destroy), this.detachEvents(), this.detachObserver();
      let {container: t, content: i} = this,
        s = this.option('classes') || {};
      for (let n of Object.values(s)) t.classList.remove(n + '');
      i &&
        (i.removeEventListener('load', this.onLoad), i.removeEventListener('error', this.onError)),
        this.detachPlugins();
    }
  }
  Object.defineProperty(L, 'defaults', {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
      content: null,
      width: 'auto',
      height: 'auto',
      panMode: 'drag',
      touch: !0,
      dragMinThreshold: 3,
      lockAxis: !1,
      mouseMoveFactor: 1,
      mouseMoveFriction: 0.12,
      zoom: !0,
      pinchToZoom: !0,
      panOnlyZoomed: 'auto',
      minScale: 1,
      maxScale: 2,
      friction: 0.25,
      dragFriction: 0.35,
      decelFriction: 0.05,
      click: 'toggleZoom',
      dblClick: !1,
      wheel: 'zoom',
      wheelLimit: 7,
      spinner: !0,
      bounds: 'auto',
      infinite: !1,
      rubberband: !0,
      bounce: !0,
      maxVelocity: 75,
      transformParent: !1,
      classes: {
        content: 'f-panzoom__content',
        isLoading: 'is-loading',
        canZoomIn: 'can-zoom_in',
        canZoomOut: 'can-zoom_out',
        isDraggable: 'is-draggable',
        isDragging: 'is-dragging',
        inFullscreen: 'in-fullscreen',
        htmlHasFullscreen: 'with-panzoom-in-fullscreen',
      },
      l10n: {
        PANUP: 'Move up',
        PANDOWN: 'Move down',
        PANLEFT: 'Move left',
        PANRIGHT: 'Move right',
        ZOOMIN: 'Zoom in',
        ZOOMOUT: 'Zoom out',
        TOGGLEZOOM: 'Toggle zoom level',
        TOGGLE1TO1: 'Toggle zoom level',
        ITERATEZOOM: 'Toggle zoom level',
        ROTATECCW: 'Rotate counterclockwise',
        ROTATECW: 'Rotate clockwise',
        FLIPX: 'Flip horizontally',
        FLIPY: 'Flip vertically',
        FITX: 'Fit horizontally',
        FITY: 'Fit vertically',
        RESET: 'Reset',
        TOGGLEFS: 'Toggle fullscreen',
      },
    },
  }),
    Object.defineProperty(L, 'Plugins', {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: {},
    }),
    ((n = i || (i = {}))[(n.Init = 0)] = 'Init'),
    (n[(n.Ready = 1)] = 'Ready'),
    (n[(n.Destroy = 2)] = 'Destroy');
  let D = (t) => {
      if (
        ('string' == typeof t && (t = {html: t}),
        !(t instanceof String || t instanceof HTMLElement))
      ) {
        let e = t.thumb;
        void 0 !== e &&
          ('string' == typeof e && (t.thumbSrc = e),
          e instanceof HTMLImageElement &&
            ((t.thumbEl = e), (t.thumbElSrc = e.src), (t.thumbSrc = e.src)),
          delete t.thumb);
      }
      return Object.assign(
        {
          html: '',
          el: null,
          isDom: !1,
          class: '',
          index: -1,
          dim: 0,
          gap: 0,
          pos: 0,
          transition: !1,
        },
        t
      );
    },
    M = (t = {}) => Object.assign({index: -1, slides: [], dim: 0, pos: -1}, t);
  class O extends $ {
    constructor(t, e) {
      super(e),
        Object.defineProperty(this, 'instance', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: t,
        });
    }
    attach() {}
    detach() {}
  }
  class I extends O {
    constructor() {
      super(...arguments),
        Object.defineProperty(this, 'isDynamic', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, 'list', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        });
    }
    onRefresh() {
      this.refresh();
    }
    build() {
      let t = this.list;
      return (
        t ||
          (u((t = document.createElement('ul')), this.cn('list')),
          t.setAttribute('role', 'tablist'),
          this.instance.container.appendChild(t),
          u(this.instance.container, this.cn('hasDots')),
          (this.list = t)),
        t
      );
    }
    refresh() {
      var t;
      let e = this.instance.pages.length,
        i = Math.min(2, this.option('minCount')),
        s = Math.max(2e3, this.option('maxCount')),
        n = this.option('dynamicFrom');
      if (e < i || e > s) return void this.cleanup();
      let r = 'number' == typeof n && e > 5 && e >= n,
        o = !this.list || this.isDynamic !== r || this.list.children.length !== e;
      o && this.cleanup();
      let a = this.build();
      if ((f(a, this.cn('isDynamic'), !!r), o))
        for (let l = 0; l < e; l++) a.append(this.createItem(l));
      let h,
        c = 0;
      for (let d of [...a.children]) {
        let p = c === this.instance.page;
        for (let m of (p && (h = d),
        f(d, this.cn('isCurrent'), p),
        null === (t = d.children[0]) ||
          void 0 === t ||
          t.setAttribute('aria-selected', p ? 'true' : 'false'),
        ['isBeforePrev', 'isPrev', 'isNext', 'isAfterNext']))
          g(d, this.cn(m));
        c++;
      }
      if (((h = h || a.firstChild), r && h)) {
        let $ = h.previousElementSibling,
          b = $ && $.previousElementSibling;
        u($, this.cn('isPrev')), u(b, this.cn('isBeforePrev'));
        let v = h.nextElementSibling,
          y = v && v.nextElementSibling;
        u(v, this.cn('isNext')), u(y, this.cn('isAfterNext'));
      }
      this.isDynamic = r;
    }
    createItem(t = 0) {
      var e;
      let i = document.createElement('li');
      i.setAttribute('role', 'presentation');
      let s = h(
        this.instance.localize(this.option('dotTpl'), [['%d', t + 1]]).replace(/\%i/g, t + '')
      );
      return (
        i.appendChild(s),
        null === (e = i.children[0]) || void 0 === e || e.setAttribute('role', 'tab'),
        i
      );
    }
    cleanup() {
      this.list && (this.list.remove(), (this.list = null)),
        (this.isDynamic = !1),
        g(this.instance.container, this.cn('hasDots'));
    }
    attach() {
      this.instance.on(['refresh', 'change'], this.onRefresh);
    }
    detach() {
      this.instance.off(['refresh', 'change'], this.onRefresh), this.cleanup();
    }
  }
  Object.defineProperty(I, 'defaults', {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
      classes: {
        list: 'f-carousel__dots',
        isDynamic: 'is-dynamic',
        hasDots: 'has-dots',
        dot: 'f-carousel__dot',
        isBeforePrev: 'is-before-prev',
        isPrev: 'is-prev',
        isCurrent: 'is-current',
        isNext: 'is-next',
        isAfterNext: 'is-after-next',
      },
      dotTpl:
        '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
      dynamicFrom: 11,
      maxCount: 1 / 0,
      minCount: 2,
    },
  });
  class B extends O {
    constructor() {
      super(...arguments),
        Object.defineProperty(this, 'container', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'prev', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'next', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        });
    }
    onRefresh() {
      let t = this.instance,
        e = t.pages.length,
        i = t.page;
      if (e < 2) return void this.cleanup();
      this.build();
      let s = this.prev,
        n = this.next;
      s &&
        n &&
        (s.removeAttribute('disabled'),
        n.removeAttribute('disabled'),
        t.isInfinite ||
          (i <= 0 && s.setAttribute('disabled', ''), i >= e - 1 && n.setAttribute('disabled', '')));
    }
    createButton(t) {
      var e;
      let i = this.instance,
        s = document.createElement('button');
      s.setAttribute('tabindex', '0'),
        s.setAttribute('title', i.localize(`{{${t.toUpperCase()}}}`)),
        u(s, this.cn('button') + ' ' + this.cn('next' === t ? 'isNext' : 'isPrev'));
      let n = i.isRTL ? ('next' === t ? 'prev' : 'next') : t;
      return (
        (s.innerHTML = i.localize(this.option(`${n}Tpl`))),
        (s.dataset[
          `carousel${
            (e = t) ? (e.match('^[a-z]') ? e.charAt(0).toUpperCase() + e.substring(1) : e) : ''
          }`
        ] = 'true'),
        s
      );
    }
    build() {
      let t = this.container;
      t ||
        ((this.container = t = document.createElement('div')),
        u(t, this.cn('container')),
        this.instance.container.appendChild(t)),
        this.next || (this.next = t.appendChild(this.createButton('next'))),
        this.prev || (this.prev = t.appendChild(this.createButton('prev')));
    }
    cleanup() {
      this.prev && this.prev.remove(),
        this.next && this.next.remove(),
        this.container && this.container.remove(),
        (this.prev = null),
        (this.next = null),
        (this.container = null);
    }
    attach() {
      this.instance.on(['refresh', 'change'], this.onRefresh);
    }
    detach() {
      this.instance.off(['refresh', 'change'], this.onRefresh), this.cleanup();
    }
  }
  Object.defineProperty(B, 'defaults', {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
      classes: {
        container: 'f-carousel__nav',
        button: 'f-button',
        isNext: 'is-next',
        isPrev: 'is-prev',
      },
      nextTpl:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
      prevTpl:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>',
    },
  });
  class H extends O {
    constructor() {
      super(...arguments),
        Object.defineProperty(this, 'selectedIndex', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'target', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'nav', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        });
    }
    addAsTargetFor(t) {
      (this.target = this.instance), (this.nav = t), this.attachEvents();
    }
    addAsNavFor(t) {
      (this.nav = this.instance), (this.target = t), this.attachEvents();
    }
    attachEvents() {
      this.nav &&
        this.target &&
        ((this.nav.options.initialSlide = this.target.options.initialPage),
        this.nav.on('ready', this.onNavReady),
        this.nav.state === i.Ready && this.onNavReady(this.nav),
        this.target.on('ready', this.onTargetReady),
        this.target.state === i.Ready && this.onTargetReady(this.target));
    }
    onNavReady(t) {
      t.on('createSlide', this.onNavCreateSlide),
        t.on('Panzoom.click', this.onNavClick),
        t.on('Panzoom.touchEnd', this.onNavTouch),
        this.onTargetChange();
    }
    onTargetReady(t) {
      t.on('change', this.onTargetChange),
        t.on('Panzoom.refresh', this.onTargetChange),
        this.onTargetChange();
    }
    onNavClick(t, e, i) {
      i.pointerType || this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
      var s, n;
      if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
      let r = i.target,
        {nav: o, target: a} = this;
      if (!o || !a || !r) return;
      let l = r.closest('[data-index]');
      if ((i.stopPropagation(), i.preventDefault(), !l)) return;
      let h = parseInt(l.dataset.index || '', 10) || 0,
        c = a.getPageForSlide(h),
        d = o.getPageForSlide(h);
      o.slideTo(d),
        a.slideTo(c, {
          friction:
            null === (n = null === (s = this.nav) || void 0 === s ? void 0 : s.plugins) ||
            void 0 === n
              ? void 0
              : n.Sync.option('friction'),
        }),
        this.markSelectedSlide(h);
    }
    onNavCreateSlide(t, e) {
      e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
      let {target: t, nav: e} = this;
      if (!t || !e || e.state !== i.Ready || t.state !== i.Ready) return;
      let s = t.pages[t.page].slides[0].index,
        n = e.getPageForSlide(s);
      this.markSelectedSlide(s), e.slideTo(n);
    }
    markSelectedSlide(t) {
      let {nav: e} = this;
      e &&
        e.state === i.Ready &&
        ((this.selectedIndex = t),
        [...e.slides].map((e) => {
          e.el && e.el.classList[e.index === t ? 'add' : 'remove']('is-nav-selected');
        }));
    }
    attach() {
      let t = this.options.target,
        e = this.options.nav;
      t ? this.addAsNavFor(t) : e && this.addAsTargetFor(e);
    }
    detach() {
      this.nav &&
        (this.nav.off('ready', this.onNavReady),
        this.nav.off('createSlide', this.onNavCreateSlide),
        this.nav.off('Panzoom.click', this.onNavClick),
        this.nav.off('Panzoom.touchEnd', this.onNavTouch)),
        (this.nav = null),
        this.target &&
          (this.target.off('ready', this.onTargetReady),
          this.target.off('refresh', this.onTargetChange),
          this.target.off('change', this.onTargetChange)),
        (this.target = null);
    }
  }
  Object.defineProperty(H, 'defaults', {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {friction: 0.35},
  });
  class W extends b {
    get axis() {
      return this.isHorizontal ? 'e' : 'f';
    }
    get isEnabled() {
      return this.state === i.Ready;
    }
    get isInfinite() {
      let t = !1,
        e = this.contentDim,
        i = this.viewportDim;
      return this.pages.length >= 2 && e > 1.5 * i && (t = this.option('infinite')), t;
    }
    get isRTL() {
      return 'rtl' === this.option('direction');
    }
    get isHorizontal() {
      return 'x' === this.option('axis');
    }
    constructor(t, e = {}, s = {}) {
      if (
        (super(),
        Object.defineProperty(this, 'userOptions', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {},
        }),
        Object.defineProperty(this, 'userPlugins', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {},
        }),
        Object.defineProperty(this, 'bp', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: '',
        }),
        Object.defineProperty(this, 'lp', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, 'state', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: i.Init,
        }),
        Object.defineProperty(this, 'page', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, 'prevPage', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'container', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, 'viewport', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'track', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'slides', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: [],
        }),
        Object.defineProperty(this, 'pages', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: [],
        }),
        Object.defineProperty(this, 'panzoom', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, 'inTransition', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: new Set(),
        }),
        Object.defineProperty(this, 'contentDim', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, 'viewportDim', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        'string' == typeof t && (t = document.querySelector(t)),
        !t || !T(t))
      )
        throw Error('No Element found');
      (this.container = t),
        (this.slideNext = a(this.slideNext.bind(this), 150)),
        (this.slidePrev = a(this.slidePrev.bind(this), 150)),
        (this.userOptions = e),
        (this.userPlugins = s),
        queueMicrotask(() => {
          this.processOptions();
        });
    }
    processOptions() {
      let t = o({}, W.defaults, this.userOptions),
        e = '',
        s = t.breakpoints;
      if (s && r(s))
        for (let [n, a] of Object.entries(s))
          window.matchMedia(n).matches && r(a) && ((e += n), o(t, a));
      (e === this.bp && this.state !== i.Init) ||
        ((this.bp = e),
        this.state === i.Ready && (t.initialSlide = this.pages[this.page].slides[0].index),
        this.state !== i.Init && this.destroy(),
        super.setOptions(t),
        !1 === this.option('enabled')
          ? this.attachEvents()
          : setTimeout(() => {
              this.init();
            }, 0));
    }
    init() {
      (this.state = i.Init),
        this.emit('init'),
        this.attachPlugins(Object.assign(Object.assign({}, W.Plugins), this.userPlugins)),
        this.initLayout(),
        this.initSlides(),
        this.updateMetrics(),
        this.setInitialPosition(),
        this.initPanzoom(),
        this.attachEvents(),
        (this.state = i.Ready),
        this.emit('ready');
    }
    initLayout() {
      let {container: t} = this,
        e = this.option('classes');
      u(t, this.cn('container')),
        f(t, e.isLTR, !this.isRTL),
        f(t, e.isRTL, this.isRTL),
        f(t, e.isVertical, !this.isHorizontal),
        f(t, e.isHorizontal, this.isHorizontal);
      let i = this.option('viewport') || t.querySelector(`.${e.viewport}`);
      i ||
        (u((i = document.createElement('div')), e.viewport),
        i.append(...l(t, `.${e.slide}`)),
        t.prepend(i));
      let s = this.option('track') || t.querySelector(`.${e.track}`);
      s || (u((s = document.createElement('div')), e.track), s.append(...Array.from(i.childNodes))),
        s.setAttribute('aria-live', 'polite'),
        i.contains(s) || i.prepend(s),
        (this.viewport = i),
        (this.track = s),
        this.emit('initLayout');
    }
    initSlides() {
      let {track: t} = this;
      if (t) {
        for (let e of ((this.slides = []),
        [...l(t, `.${this.cn('slide')}`)].forEach((t) => {
          if (T(t)) {
            let e = D({el: t, isDom: !0, index: this.slides.length});
            this.slides.push(e), this.emit('initSlide', e, this.slides.length);
          }
        }),
        this.option('slides', []))) {
          let i = D(e);
          (i.index = this.slides.length),
            this.slides.push(i),
            this.emit('initSlide', i, this.slides.length);
        }
        this.emit('initSlides');
      }
    }
    setInitialPage() {
      let t = 0,
        e = this.option('initialSlide');
      (t =
        'number' == typeof e
          ? this.getPageForSlide(e)
          : parseInt(this.option('initialPage', 0) + '', 10) || 0),
        (this.page = t);
    }
    setInitialPosition() {
      if (!this.track || !this.pages.length) return;
      let t = this.isHorizontal,
        e = this.page;
      this.pages[e] || (this.page = e = 0);
      let i = this.pages[e].pos * (this.isRTL && t ? 1 : -1),
        s = t ? `${i}px` : '0',
        n = t ? '0' : `${i}px`;
      (this.track.style.transform = `translate3d(${s}, ${n}, 0) scale(1)`),
        this.option('adaptiveHeight') && this.setViewportHeight();
    }
    initPanzoom() {
      this.panzoom && (this.panzoom.destroy(), (this.panzoom = null));
      let t = this.option('Panzoom') || {};
      (this.panzoom = new L(
        this.viewport,
        o(
          {},
          {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? 'x' : 'y',
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t) => !(this.pages.length < 2 && !t.options.infinite),
            bounds: () => this.getBounds(),
            maxVelocity: (t) =>
              Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0,
          },
          t
        )
      )),
        this.panzoom.on('*', (t, e, ...i) => {
          this.emit(`Panzoom.${e}`, t, ...i);
        }),
        this.panzoom.on('decel', this.onDecel),
        this.panzoom.on('refresh', this.onRefresh),
        this.panzoom.on('beforeTransform', this.onBeforeTransform),
        this.panzoom.on('endAnimation', this.onEndAnimation);
    }
    attachEvents() {
      let t = this.container;
      t &&
        (t.addEventListener('click', this.onClick, {passive: !1, capture: !1}),
        t.addEventListener('slideTo', this.onSlideTo)),
        window.addEventListener('resize', this.onResize);
    }
    createPages() {
      let t = [],
        {contentDim: e, viewportDim: i} = this,
        s = this.option('slidesPerPage');
      if ('number' == typeof s && e > i) {
        for (let n = 0; n < this.slides.length; n += s)
          t.push(M({index: n, slides: this.slides.slice(n, n + s)}));
        return t;
      }
      let r = 0,
        o = 0;
      for (let a of this.slides)
        (!t.length || o + a.dim > i) && (t.push(M()), (r = t.length - 1), (o = 0)),
          (o += a.dim + a.gap),
          t[r].slides.push(a);
      return t;
    }
    processPages() {
      let t = this.pages,
        {contentDim: e, viewportDim: i} = this,
        s = this.option('center'),
        n = this.option('fill'),
        r = n && s && e > i && !this.isInfinite;
      if (
        (t.forEach((t, n) => {
          for (let [o, a] of ((t.index = n),
          (t.pos = t.slides[0].pos),
          (t.dim = 0),
          t.slides.entries()))
            (t.dim += a.dim), o < t.slides.length - 1 && (t.dim += a.gap);
          r && t.pos + 0.5 * t.dim < 0.5 * i
            ? (t.pos = 0)
            : r && t.pos + 0.5 * t.dim >= e - 0.5 * i
            ? (t.pos = e - i)
            : s && (t.pos += -0.5 * (i - t.dim));
        }),
        t.forEach((t, s) => {
          n &&
            !this.isInfinite &&
            e > i &&
            ((t.pos = Math.max(t.pos, 0)), (t.pos = Math.min(t.pos, e - i))),
            (t.pos = c(t.pos, 1e3)),
            (t.dim = c(t.dim, 1e3)),
            t.pos < 0.1 && t.pos > -0.1 && (t.pos = 0);
        }),
        this.isInfinite)
      )
        return t;
      let o = [],
        a;
      return (
        t.forEach((t) => {
          let e = Object.assign({}, t);
          a && e.pos === a.pos
            ? ((a.dim += e.dim), (a.slides = [...a.slides, ...e.slides]))
            : ((e.index = o.length), (a = e), o.push(e));
        }),
        o
      );
    }
    getPageFromIndex(t = 0) {
      let e = this.pages.length,
        i;
      return (
        (t = parseInt((t || 0).toString()) || 0),
        (i = this.isInfinite ? ((t % e) + e) % e : Math.max(Math.min(t, this.pages.length - 1), 0))
      );
    }
    getSlideMetrics(t) {
      let e = this.isHorizontal ? 'width' : 'height',
        i = 0,
        s = 0,
        n = t.el;
      n
        ? (i = parseFloat(n.dataset[e] || '') || 0)
        : (((n = document.createElement('div')).style.visibility = 'hidden'),
          u(n, this.cn('slide') + ' ' + t.class),
          (this.track || document.body).prepend(n)),
        i
          ? ((n.style[e] = `${i}px`), (n.style['width' === e ? 'height' : 'width'] = ''))
          : (i = n.getBoundingClientRect()[e]);
      let r = getComputedStyle(n);
      return (
        'content-box' === r.boxSizing &&
          (this.isHorizontal
            ? ((i += parseFloat(r.paddingLeft) || 0), (i += parseFloat(r.paddingRight) || 0))
            : ((i += parseFloat(r.paddingTop) || 0), (i += parseFloat(r.paddingBottom) || 0))),
        (s = parseFloat(r[this.isHorizontal ? 'marginRight' : 'marginBottom']) || 0),
        this.isHorizontal,
        t.el || n.remove(),
        {dim: c(i, 1e3), gap: c(s, 1e3)}
      );
    }
    getBounds() {
      let t = {min: 0, max: 0};
      if (this.isInfinite) t = {min: -1 / 0, max: 1 / 0};
      else if (this.pages.length) {
        let e = this.pages[0].pos,
          i = this.pages[this.pages.length - 1].pos;
        t = this.isRTL && this.isHorizontal ? {min: e, max: i} : {min: -1 * i, max: -1 * e};
      }
      return {
        x: this.isHorizontal ? t : {min: 0, max: 0},
        y: this.isHorizontal ? {min: 0, max: 0} : t,
      };
    }
    repositionSlides() {
      let t,
        {viewport: e, viewportDim: i, contentDim: s, page: n, pages: r} = this,
        o = 0,
        a = 0,
        l = 0,
        h = 0;
      for (let d of (this.panzoom
        ? (h = -1 * this.panzoom.current[this.axis])
        : r[n] && (h = r[n].pos || 0),
      (t = this.isHorizontal ? (this.isRTL ? 'right' : 'left') : 'top'),
      this.isRTL && this.isHorizontal && (h *= -1),
      this.slides))
        d.el
          ? ('top' === t
              ? ((d.el.style.right = ''), (d.el.style.left = ''))
              : (d.el.style.top = ''),
            d.index !== o
              ? (d.el.style[t] = 0 === a ? '' : `${c(a, 1e3)}px`)
              : (d.el.style[t] = ''),
            (l += d.dim + d.gap),
            o++)
          : (a += d.dim + d.gap);
      if (this.isInfinite && l && e) {
        let u = this.isHorizontal,
          g = getComputedStyle(e),
          f = 'padding',
          p = parseFloat(g[f + (u ? 'Left' : 'Top')]);
        for (let m of ((h -= p),
        (i += p),
        (i += parseFloat(g[f + (u ? 'Right' : 'Bottom')])),
        this.slides))
          m.el &&
            (c(m.pos) < c(i) &&
              c(m.pos + m.dim + m.gap) < c(h) &&
              c(h) > c(s - i) &&
              (m.el.style[t] = `${c(a + l, 1e3)}px`),
            c(m.pos + m.gap) >= c(s - i) &&
              c(m.pos) > c(h + i) &&
              c(h) < c(i) &&
              (m.el.style[t] = `-${c(l, 1e3)}px`));
      }
      let $,
        b,
        v = [...this.inTransition];
      if ((v.length > 1 && (($ = this.pages[v[0]]), (b = this.pages[v[1]])), $ && b)) {
        let y = 0;
        for (let _ of this.slides)
          _.el
            ? this.inTransition.has(_.index) &&
              0 > $.slides.indexOf(_) &&
              (_.el.style[t] = `${c(y + ($.pos - b.pos), 1e3)}px`)
            : (y += _.dim + _.gap);
      }
    }
    createSlideEl(t) {
      if (!this.track || !t || t.el) return;
      let e = document.createElement('div');
      u(e, this.cn('slide')), u(e, t.class), u(e, t.customClass), t.html && (e.innerHTML = t.html);
      let i = [];
      this.slides.forEach((t, e) => {
        t.el && i.push(e);
      });
      let s = t.index,
        n = null;
      if (i.length) {
        let r = i.reduce((t, e) => (Math.abs(e - s) < Math.abs(t - s) ? e : t));
        n = this.slides[r];
      }
      let o = n && n.el ? (n.index < t.index ? n.el.nextSibling : n.el) : null;
      this.track.insertBefore(e, this.track.contains(o) ? o : null),
        (t.el = e),
        this.emit('createSlide', t);
    }
    removeSlideEl(t, e = !1) {
      let i = t.el;
      if (!i) return;
      if ((g(i, this.cn('isSelected')), t.isDom && !e))
        return (
          i.removeAttribute('aria-hidden'),
          i.removeAttribute('data-index'),
          g(i, this.cn('isSelected')),
          void (i.style.left = '')
        );
      this.emit('removeSlide', t);
      let s = new CustomEvent('animationend');
      i.dispatchEvent(s), t.el && t.el.remove(), (t.el = null);
    }
    transitionTo(t = 0, e = this.option('transition')) {
      if (!e) return !1;
      let {pages: i, panzoom: s} = this;
      t = parseInt((t || 0).toString()) || 0;
      let n = this.getPageFromIndex(t);
      if (!s || !i[n] || i.length < 2 || i[this.page].slides[0].dim < this.viewportDim) return !1;
      let r = t > this.page ? 1 : -1,
        o = this.pages[n].pos * (this.isRTL ? 1 : -1);
      if (this.page === n && c(o, 1e3) === c(s.target[this.axis], 1e3)) return !1;
      this.clearTransitions();
      let a = s.isResting;
      u(this.container, this.cn('inTransition'));
      let l = this.pages[this.page].slides[0],
        h = this.pages[n].slides[0];
      this.inTransition.add(h.index), this.createSlideEl(h);
      let d = l.el,
        g = h.el;
      a || 'slide' === e || ((e = 'fadeFast'), (d = null));
      let f = this.isRTL ? 'next' : 'prev',
        p = this.isRTL ? 'prev' : 'next';
      return (
        d &&
          (this.inTransition.add(l.index),
          (l.transition = e),
          d.addEventListener('animationend', this.onAnimationEnd),
          d.classList.add(`f-${e}Out`, `to-${r > 0 ? p : f}`)),
        g &&
          ((h.transition = e),
          g.addEventListener('animationend', this.onAnimationEnd),
          g.classList.add(`f-${e}In`, `from-${r > 0 ? f : p}`)),
        s.panTo({x: this.isHorizontal ? o : 0, y: this.isHorizontal ? 0 : o, friction: 0}),
        this.onChange(n),
        !0
      );
    }
    manageSlideVisiblity() {
      let t = new Set(),
        e = new Set(),
        i = this.getVisibleSlides(parseFloat(this.option('preload', 0) + '') || 0);
      for (let s of this.slides) i.has(s) ? t.add(s) : e.add(s);
      for (let n of this.inTransition) t.add(this.slides[n]);
      for (let r of t) this.createSlideEl(r), this.lazyLoadSlide(r);
      for (let o of e) t.has(o) || this.removeSlideEl(o);
      this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
      if (!this.pages[this.page] || !this.pages[this.page].slides) return;
      let t = 'aria-hidden',
        e = this.cn('isSelected');
      if (e)
        for (let i of this.slides)
          i.el &&
            ((i.el.dataset.index = `${i.index}`),
            this.pages[this.page].slides.includes(i)
              ? (i.el.classList.contains(e) || (u(i.el, e), this.emit('selectSlide', i)),
                i.el.removeAttribute(t))
              : (i.el.classList.contains(e) && (g(i.el, e), this.emit('unselectSlide', i)),
                i.el.setAttribute(t, 'true')));
    }
    flipInfiniteTrack() {
      let t = this.panzoom;
      if (!t || !this.isInfinite) return;
      let e = 'x' === this.option('axis') ? 'e' : 'f',
        {viewportDim: i, contentDim: s} = this,
        n = t.current[e],
        r = t.target[e] - n,
        o = 0,
        a = 0.5 * i,
        l = s;
      this.isRTL && this.isHorizontal
        ? (n < -a && ((o = -1), (n += l)), n > l - a && ((o = 1), (n -= l)))
        : (n > a && ((o = 1), (n -= l)), n < -l + a && ((o = -1), (n += l))),
        o && ((t.current[e] = n), (t.target[e] = n + r));
    }
    lazyLoadSlide(t) {
      let e = this,
        i = t && t.el;
      if (!i) return;
      let s = new Set(),
        n = 'f-fadeIn';
      i.querySelectorAll('[data-lazy-srcset]').forEach((t) => {
        t instanceof HTMLImageElement && s.add(t);
      });
      let r = Array.from(i.querySelectorAll('[data-lazy-src]'));
      i.dataset.lazySrc && r.push(i),
        r.map((t) => {
          t instanceof HTMLImageElement
            ? s.add(t)
            : T(t) &&
              ((t.style.backgroundImage = `url('${t.dataset.lazySrc || ''}')`),
              delete t.dataset.lazySrc);
        });
      let o = (t, i, s) => {
        s && (s.remove(), (s = null)),
          i.complete &&
            (i.classList.add(n),
            setTimeout(() => {
              i.classList.remove(n);
            }, 350),
            (i.style.display = '')),
          this.option('adaptiveHeight') &&
            t.el &&
            this.pages[this.page].slides.indexOf(t) > -1 &&
            (e.updateMetrics(), e.setViewportHeight()),
          this.emit('load', t);
      };
      for (let a of s) {
        let l = null;
        (a.src = a.dataset.lazySrcset || a.dataset.lazySrc || ''),
          delete a.dataset.lazySrc,
          delete a.dataset.lazySrcset,
          (a.style.display = 'none'),
          a.addEventListener('error', () => {
            o(t, a, l);
          }),
          a.addEventListener('load', () => {
            o(t, a, l);
          }),
          setTimeout(() => {
            a.parentNode &&
              t.el &&
              (a.complete ? o(t, a, l) : ((l = h(p)), a.parentNode.insertBefore(l, a)));
          }, 300);
      }
    }
    onAnimationEnd(t) {
      var e;
      let i = t.target,
        s = i ? parseInt(i.dataset.index || '', 10) || 0 : -1,
        n = this.slides[s],
        r = t.animationName;
      if (!i || !n || !r) return;
      let o = !!this.inTransition.has(s) && n.transition;
      o && r.substring(0, o.length + 2) === `f-${o}` && this.inTransition.delete(s),
        this.inTransition.size || this.clearTransitions(),
        s === this.page &&
          (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) &&
          this.emit('settle');
    }
    onDecel(t, e = 0, i = 0, s = 0, n = 0) {
      let r = this.isRTL,
        o = this.isHorizontal,
        a = this.axis,
        l = this.pages.length,
        h = Math.abs(Math.atan2(i, e) / (Math.PI / 180)),
        c = 0;
      if (((c = h > 45 && h < 135 ? (o ? 0 : i) : o ? e : 0), !l)) return;
      let d = this.option('dragFree'),
        u = this.page,
        g = t.target[a] * (this.isRTL && o ? 1 : -1),
        {pageIndex: f} = this.getPageFromPosition(g),
        p = t.current[a] * (r && o ? 1 : -1),
        {page: m} = this.getPageFromPosition(p);
      d
        ? this.onChange(f)
        : (Math.abs(c) > 5
            ? ((this.pages.length < 3 ||
                Math.max(Math.abs(s), Math.abs(n)) > this.pages[u].slides[0].dim) &&
                (u = m),
              (u = r && o ? (c < 0 ? u - 1 : u + 1) : c < 0 ? u + 1 : u - 1))
            : (u = m),
          this.slideTo(u, {transition: !1, friction: t.option('decelFriction')}));
    }
    onClick(t) {
      let e = t.target,
        i = e && T(e) ? e.dataset : null,
        s,
        n;
      i &&
        (void 0 !== i.carouselPage
          ? ((n = 'slideTo'), (s = i.carouselPage))
          : void 0 !== i.carouselNext
          ? (n = 'slideNext')
          : void 0 !== i.carouselPrev && (n = 'slidePrev')),
        n
          ? (t.preventDefault(),
            t.stopPropagation(),
            e && !e.hasAttribute('disabled') && this[n](s))
          : this.emit('click', t);
    }
    onSlideTo(t) {
      let e = t.detail || 0;
      this.slideTo(this.getPageForSlide(e), {friction: 0});
    }
    onChange(t, e = 0) {
      let i = this.page;
      (this.prevPage = i),
        (this.page = t),
        this.option('adaptiveHeight') && this.setViewportHeight(),
        t !== i && (this.markSelectedSlides(), this.emit('change', t, i, e));
    }
    onRefresh() {
      let t = this.contentDim,
        e = this.viewportDim;
      this.updateMetrics(),
        (this.contentDim === t && this.viewportDim === e) ||
          this.slideTo(this.page, {friction: 0, transition: !1});
    }
    onResize() {
      this.option('breakpoints') && this.processOptions();
    }
    onBeforeTransform(t) {
      this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()),
        (this.lp = t.current.e);
    }
    onEndAnimation() {
      this.inTransition.size || this.emit('settle');
    }
    reInit(t = null, e = null) {
      this.destroy(),
        (this.state = i.Init),
        (this.userOptions = t || this.userOptions),
        (this.userPlugins = e || this.userPlugins),
        this.processOptions();
    }
    slideTo(
      t = 0,
      {friction: e = this.option('friction'), transition: s = this.option('transition')} = {}
    ) {
      if (this.state === i.Destroy) return;
      let n = this.panzoom,
        r = this.pages.length;
      if (!n || !r || this.transitionTo(t, s)) return;
      let o = this.axis,
        a = this.getPageFromIndex(t),
        l = this.pages[a].pos,
        h = 0;
      if (this.isInfinite) {
        let c = n.current[o] * (this.isRTL && this.isHorizontal ? 1 : -1),
          d = this.contentDim,
          u = l + d,
          g = l - d;
        Math.abs(c - u) < Math.abs(c - l) && ((l = u), (h = 1)),
          Math.abs(c - g) < Math.abs(c - l) && ((l = g), (h = -1));
      }
      (l *= this.isRTL && this.isHorizontal ? 1 : -1),
        0.1 > Math.abs(n.target[o] - l) ||
          (n.panTo({x: this.isHorizontal ? l : 0, y: this.isHorizontal ? 0 : l, friction: e}),
          this.onChange(a, h));
    }
    slideToClosest(t) {
      if (this.panzoom) {
        let {pageIndex: e} = this.getPageFromPosition(
          this.panzoom.current[this.isHorizontal ? 'e' : 'f']
        );
        this.slideTo(e, t);
      }
    }
    slideNext() {
      this.slideTo(this.page + 1);
    }
    slidePrev() {
      this.slideTo(this.page - 1);
    }
    clearTransitions() {
      this.inTransition.clear(), g(this.container, this.cn('inTransition'));
      let t = ['to-prev', 'to-next', 'from-prev', 'from-next'];
      for (let e of this.slides) {
        let i = e.el;
        if (i) {
          i.removeEventListener('animationend', this.onAnimationEnd), i.classList.remove(...t);
          let s = e.transition;
          s && i.classList.remove(`f-${s}Out`, `f-${s}In`);
        }
      }
      this.manageSlideVisiblity();
    }
    prependSlide(t) {
      var e, i;
      let s = Array.isArray(t) ? t : [t];
      for (let n of s.reverse()) this.slides.unshift(D(n));
      for (let r = 0; r < this.slides.length; r++) this.slides[r].index = r;
      let o = (null === (e = this.pages[this.page]) || void 0 === e ? void 0 : e.pos) || 0;
      (this.page += s.length), this.updateMetrics();
      let a = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0;
      if (this.panzoom) {
        let l = this.isRTL ? o - a : a - o;
        (this.panzoom.target.e -= l), (this.panzoom.current.e -= l), this.panzoom.requestTick();
      }
    }
    appendSlide(t) {
      let e = Array.isArray(t) ? t : [t];
      for (let i of e) {
        let s = D(i);
        (s.index = this.slides.length),
          this.slides.push(s),
          this.emit('initSlide', i, this.slides.length);
      }
      this.updateMetrics();
    }
    removeSlide(t) {
      let e = this.slides.length;
      (t = ((t % e) + e) % e), this.removeSlideEl(this.slides[t], !0), this.slides.splice(t, 1);
      for (let i = 0; i < this.slides.length; i++) this.slides[i].index = i;
      this.updateMetrics(), this.slideTo(this.page, {friction: 0, transition: !1});
    }
    updateMetrics() {
      let {panzoom: t, viewport: e, track: s, isHorizontal: n} = this;
      if (!s) return;
      let r = n ? 'width' : 'height';
      if (e) {
        let o = c(e.getBoundingClientRect()[r], 1e3),
          a = getComputedStyle(e),
          l = 'padding';
        (o -=
          parseFloat(a[l + (n ? 'Left' : 'Top')]) + parseFloat(a[l + (n ? 'Right' : 'Bottom')])),
          (this.viewportDim = o);
      }
      let h,
        d = this.pages.length,
        u = 0;
      for (let [g, f] of this.slides.entries()) {
        let p = 0,
          m = 0;
        !f.el && h
          ? ((p = h.dim), (m = h.gap))
          : (({dim: p, gap: m} = this.getSlideMetrics(f)), (h = f)),
          (p = c(p, 1e3)),
          (m = c(m, 1e3)),
          (f.dim = p),
          (f.gap = m),
          (f.pos = u),
          (u += p),
          (this.isInfinite || g < this.slides.length - 1) && (u += m);
      }
      let $ = this.contentDim;
      (u = c(u, 1e3)),
        (this.contentDim = u),
        t &&
          ((t.contentRect[r] = u),
          (t.contentRect['e' === this.axis ? 'fullWidth' : 'fullHeight'] = u)),
        (this.pages = this.createPages()),
        (this.pages = this.processPages()),
        this.state === i.Init && this.setInitialPage(),
        (this.page = Math.max(0, Math.min(this.page, this.pages.length - 1))),
        t &&
          d === this.pages.length &&
          Math.abs(u - $) > 0.5 &&
          ((t.target[this.axis] = -1 * this.pages[this.page].pos),
          (t.current[this.axis] = -1 * this.pages[this.page].pos),
          t.stop()),
        this.manageSlideVisiblity(),
        this.emit('refresh');
    }
    getProgress(t, e = !1) {
      void 0 === t && (t = this.page);
      let i = this.panzoom,
        s = this.pages[t] || 0;
      if (!s || !i) return 0;
      let n = -1 * i.current.e,
        r = this.contentDim;
      var o = [
        c((n - s.pos) / (1 * s.dim), 1e3),
        c((n + r - s.pos) / (1 * s.dim), 1e3),
        c((n - r - s.pos) / (1 * s.dim), 1e3),
      ].reduce(function (t, e) {
        return Math.abs(e) < Math.abs(t) ? e : t;
      });
      return e ? o : Math.max(-1, Math.min(1, o));
    }
    setViewportHeight() {
      let {page: t, pages: e, viewport: i, isHorizontal: s} = this;
      if (!i || !e[t]) return;
      let n = 0;
      s &&
        this.track &&
        ((this.track.style.height = 'auto'),
        e[t].slides.forEach((t) => {
          t.el && (n = Math.max(n, t.el.offsetHeight));
        })),
        (i.style.height = n ? `${n}px` : '');
    }
    getPageForSlide(t) {
      for (let e of this.pages) for (let i of e.slides) if (i.index === t) return e.index;
      return -1;
    }
    getVisibleSlides(t = 0) {
      var e;
      let i = new Set(),
        {contentDim: s, viewportDim: n, pages: r, page: o} = this;
      s =
        s + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) ||
        0;
      let a = 0;
      (a = this.panzoom ? -1 * this.panzoom.current[this.axis] : (r[o] && r[o].pos) || 0),
        this.isInfinite && (a -= Math.floor(a / s) * s),
        this.isRTL && this.isHorizontal && (a *= -1);
      let l = a - n * t,
        h = a + n * (t + 1),
        c = this.isInfinite ? [-1, 0, 1] : [0];
      for (let d of this.slides)
        for (let u of c) {
          let g = d.pos + u * s,
            f = d.pos + d.dim + d.gap + u * s;
          g < h && f > l && i.add(d);
        }
      return i;
    }
    getPageFromPosition(t) {
      let {viewportDim: e, contentDim: i} = this,
        s = this.pages.length,
        n = this.slides.length,
        r = this.slides[n - 1],
        o = 0,
        a = 0,
        l = 0,
        h = this.option('center');
      h && (t += 0.5 * e),
        this.isInfinite || (t = Math.max(this.slides[0].pos, Math.min(t, r.pos)));
      let c = i + r.gap;
      (l = Math.floor(t / c) || 0), (t -= l * c);
      let d = r,
        u = this.slides.find((e) => {
          let i = t + (d && !h ? 0.5 * d.dim : 0);
          return (d = e), e.pos <= i && e.pos + e.dim + e.gap > i;
        });
      return u || (u = r), {page: (o = (a = this.getPageForSlide(u.index)) + l * s), pageIndex: a};
    }
    destroy() {
      if ([i.Destroy].includes(this.state)) return;
      this.state = i.Destroy;
      let {container: t, viewport: e, track: s, slides: n, panzoom: r} = this,
        o = this.option('classes');
      for (let [a, l] of (t.removeEventListener('click', this.onClick, {passive: !1, capture: !1}),
      t.removeEventListener('slideTo', this.onSlideTo),
      window.removeEventListener('resize', this.onResize),
      r && (r.destroy(), (this.panzoom = null)),
      n &&
        n.forEach((t) => {
          this.removeSlideEl(t);
        }),
      this.detachPlugins(),
      (this.track = null),
      (this.viewport = null),
      (this.page = 0),
      e && s && e.replaceWith(...s.childNodes),
      Object.entries(o)))
        'container' !== a && l && t.classList.remove(l);
      this.slides = [];
      let h = this.events.get('ready');
      (this.events = new Map()), h && this.events.set('ready', h);
    }
  }
  Object.defineProperty(W, 'Panzoom', {enumerable: !0, configurable: !0, writable: !0, value: L}),
    Object.defineProperty(W, 'defaults', {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: {
        viewport: null,
        track: null,
        enabled: !0,
        slides: [],
        axis: 'x',
        transition: 'fade',
        preload: 1,
        slidesPerPage: 'auto',
        initialPage: 0,
        friction: 0.12,
        Panzoom: {decelFriction: 0.12},
        center: !0,
        infinite: !0,
        fill: !0,
        dragFree: !1,
        adaptiveHeight: !1,
        direction: 'ltr',
        classes: {
          container: 'f-carousel',
          viewport: 'f-carousel__viewport',
          track: 'f-carousel__track',
          slide: 'f-carousel__slide',
          isLTR: 'is-ltr',
          isRTL: 'is-rtl',
          isHorizontal: 'is-horizontal',
          isVertical: 'is-vertical',
          inTransition: 'in-transition',
          isSelected: 'is-selected',
        },
        l10n: {NEXT: 'Next slide', PREV: 'Previous slide', GOTO: 'Go to slide #%d'},
      },
    }),
    Object.defineProperty(W, 'Plugins', {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: {Navigation: B, Dots: I, Sync: H},
    }),
    (t.Carousel = W);
}),
  (function (t, e) {
    'object' == typeof exports && 'undefined' != typeof module
      ? e(exports)
      : 'function' == typeof define && define.amd
      ? define(['exports'], e)
      : e(
          ((t = 'undefined' != typeof globalThis ? globalThis : t || self).window = t.window || {})
        );
  })(this, function (t) {
    'use strict';
    var e, i, s;
    let n = (t, ...e) => {
        let i = e.length;
        for (let s = 0; s < i; s++) {
          let r = e[s] || {};
          Object.entries(r).forEach(([e, i]) => {
            var s;
            let r = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {[e]: r}),
              'object' == typeof (s = i) &&
              null !== s &&
              s.constructor === Object &&
              '[object Object]' === Object.prototype.toString.call(s)
                ? Object.assign(t[e], n(r, i))
                : Array.isArray(i)
                ? Object.assign(t, {[e]: [...i]})
                : Object.assign(t, {[e]: i});
          });
        }
        return t;
      },
      r = function (t) {
        var e = new DOMParser().parseFromString(t, 'text/html').body;
        if (e.childElementCount > 1) {
          for (var i = document.createElement('div'); e.firstChild; ) i.appendChild(e.firstChild);
          return i;
        }
        return e.firstChild;
      },
      o = (t) => `${t || ''}`.split(' ').filter((t) => !!t),
      a = (t, e) => {
        t &&
          o(e).forEach((e) => {
            t.classList.add(e);
          });
      },
      l = (t, e, i) => {
        o(e).forEach((e) => {
          t && t.classList.toggle(e, i || !1);
        });
      },
      h = function (t, e) {
        return t.split('.').reduce((t, e) => ('object' == typeof t ? t[e] : void 0), e);
      };
    class c {
      constructor(t = {}) {
        for (let e of (Object.defineProperty(this, 'options', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: t,
        }),
        Object.defineProperty(this, 'events', {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: new Map(),
        }),
        this.setOptions(t),
        Object.getOwnPropertyNames(Object.getPrototypeOf(this))))
          e.startsWith('on') && 'function' == typeof this[e] && (this[e] = this[e].bind(this));
      }
      setOptions(t) {
        for (let [e, i] of ((this.options = t ? n({}, this.constructor.defaults, t) : {}),
        Object.entries(this.option('on') || {})))
          this.on(e, i);
      }
      option(t, ...e) {
        let i = h(t, this.options);
        return i && 'function' == typeof i && (i = i.call(this, this, ...e)), i;
      }
      optionFor(t, e, i, ...s) {
        var n;
        let r = h(e, t);
        'string' != typeof (n = r) || isNaN(n) || isNaN(parseFloat(n)) || (r = parseFloat(r)),
          'true' === r && (r = !0),
          'false' === r && (r = !1),
          r && 'function' == typeof r && (r = r.call(this, this, t, ...s));
        let o = h(e, this.options);
        return (
          o && 'function' == typeof o
            ? (r = o.call(this, this, t, ...s, r))
            : void 0 === r && (r = o),
          void 0 === r ? i : r
        );
      }
      cn(t) {
        let e = this.options.classes;
        return (e && e[t]) || '';
      }
      localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i) => {
          let s = '';
          return (
            i
              ? (s = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`))
              : e && (s = this.option(`l10n.${e}`)),
            s || (s = t),
            s
          );
        });
        for (let i = 0; i < e.length; i++) t = t.split(e[i][0]).join(e[i][1]);
        return (t = t.replace(/\{\{(.*?)\}\}/g, (t, e) => e));
      }
      on(t, e) {
        let i = [];
        'string' == typeof t ? (i = t.split(' ')) : Array.isArray(t) && (i = t),
          this.events || (this.events = new Map()),
          i.forEach((t) => {
            let i = this.events.get(t);
            i || (this.events.set(t, []), (i = [])),
              i.includes(e) || i.push(e),
              this.events.set(t, i);
          });
      }
      off(t, e) {
        let i = [];
        'string' == typeof t ? (i = t.split(' ')) : Array.isArray(t) && (i = t),
          i.forEach((t) => {
            let i = this.events.get(t);
            if (Array.isArray(i)) {
              let s = i.indexOf(e);
              s > -1 && i.splice(s, 1);
            }
          });
      }
      emit(t, ...e) {
        [...(this.events.get(t) || [])].forEach((t) => t(this, ...e)),
          '*' !== t && this.emit('*', t, ...e);
      }
    }
    Object.defineProperty(c, 'version', {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: '5.0.14',
    }),
      Object.defineProperty(c, 'defaults', {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: {},
      });
    class d extends c {
      constructor(t, e) {
        super(e),
          Object.defineProperty(this, 'instance', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t,
          });
      }
      attach() {}
      detach() {}
    }
    ((i = e || (e = {}))[(i.Init = 0)] = 'Init'),
      (i[(i.Error = 1)] = 'Error'),
      (i[(i.Ready = 2)] = 'Ready'),
      (i[(i.Panning = 3)] = 'Panning'),
      (i[(i.Mousemove = 4)] = 'Mousemove'),
      (i[(i.Destroy = 5)] = 'Destroy');
    let u = (t, e = 1e4) => Math.round(((t = parseFloat(t + '') || 0) + Number.EPSILON) * e) / e,
      g = {
        classes: {
          container: 'f-thumbs f-carousel__thumbs',
          viewport: 'f-thumbs__viewport',
          track: 'f-thumbs__track',
          slide: 'f-thumbs__slide',
          isResting: 'is-resting',
          isSelected: 'is-selected',
          isLoading: 'is-loading',
          hasThumbs: 'has-thumbs',
        },
        minCount: 2,
        parentEl: null,
        thumbTpl:
          '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
        type: 'modern',
      };
    (t.States = void 0),
      ((s = t.States || (t.States = {}))[(s.Init = 0)] = 'Init'),
      (s[(s.Ready = 1)] = 'Ready'),
      (s[(s.Hidden = 2)] = 'Hidden'),
      (s[(s.Disabled = 3)] = 'Disabled');
    class f extends d {
      constructor() {
        super(...arguments),
          Object.defineProperty(this, 'type', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 'modern',
          }),
          Object.defineProperty(this, 'container', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null,
          }),
          Object.defineProperty(this, 'track', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null,
          }),
          Object.defineProperty(this, 'carousel', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null,
          }),
          Object.defineProperty(this, 'panzoom', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null,
          }),
          Object.defineProperty(this, 'thumbWidth', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0,
          }),
          Object.defineProperty(this, 'thumbClipWidth', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0,
          }),
          Object.defineProperty(this, 'thumbHeight', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0,
          }),
          Object.defineProperty(this, 'thumbGap', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0,
          }),
          Object.defineProperty(this, 'thumbExtraGap', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0,
          }),
          Object.defineProperty(this, 'shouldCenter', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !0,
          }),
          Object.defineProperty(this, 'state', {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t.States.Init,
          });
      }
      formatThumb(t, e) {
        return this.instance.localize(e, [
          ['%i', t.index],
          ['%d', t.index + 1],
          [
            '%s',
            t.thumbSrc ||
              'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
          ],
        ]);
      }
      getSlides() {
        let t = [],
          e = this.option('thumbTpl') || '';
        if (e)
          for (let i of this.instance.slides || []) {
            let s = '';
            i.type &&
              ((s = `for-${i.type}`),
              i.type &&
                ['video', 'youtube', 'vimeo', 'html5video'].includes(i.type) &&
                (s += ' for-video')),
              t.push({html: this.formatThumb(i, e), customClass: s});
          }
        return t;
      }
      onInitSlide(t, e) {
        let i = e.el;
        i &&
          ((e.thumbSrc = i.dataset.thumbSrc || e.thumbSrc || ''),
          (e.thumbClipWidth = parseFloat(i.dataset.thumbClipWidth || '') || e.thumbClipWidth || 0),
          (e.thumbHeight = parseFloat(i.dataset.thumbHeight || '') || e.thumbHeight || 0));
      }
      onInitSlides() {
        this.state === t.States.Init && this.build();
      }
      onRefreshM() {
        this.refreshModern();
      }
      onChangeM() {
        'modern' === this.type && ((this.shouldCenter = !0), this.centerModern());
      }
      onClickModern(t) {
        var e;
        t.preventDefault(), t.stopPropagation();
        let i = this.instance,
          s = i.page,
          n = (t) => {
            if (t) {
              let e = t.closest('[data-carousel-index]');
              if (e) return parseInt(e.dataset.carouselIndex || '', 10) || 0;
            }
            return -1;
          },
          r = (t, e) => {
            let i = document.elementFromPoint(t, e);
            return i ? n(i) : -1;
          },
          o = n(t.target),
          a,
          l;
        o < 0 && (o = r(t.clientX + this.thumbGap, t.clientY)) === s && (o = s - 1),
          o < 0 && (o = r(t.clientX - this.thumbGap, t.clientY)) === s && (o = s + 1),
          o < 0 &&
            (o =
              ((e = this.thumbExtraGap),
              (a = r(t.clientX - e, t.clientY)),
              (l = r(t.clientX + e, t.clientY)),
              o < 0 && a === s && (o = s + 1),
              o < 0 && l === s && (o = s - 1),
              o)),
          o === s ? this.centerModern() : o > -1 && o < i.pages.length && i.slideTo(o);
      }
      onTransformM() {
        if ('modern' !== this.type) return;
        let {instance: t, container: i, track: s} = this,
          n = t.panzoom;
        if (!(i && s && n && this.panzoom)) return;
        l(i, this.cn('isResting'), n.state !== e.Init && n.isResting);
        let r = this.thumbGap,
          o = this.thumbExtraGap,
          a = this.thumbClipWidth,
          h = 0,
          c = 0,
          d = 0;
        for (let u of t.slides) {
          let g = u.index,
            f = u.thumbSlideEl;
          if (!f) continue;
          l(f, this.cn('isSelected'), g === t.page),
            (c = 1 - Math.abs(t.getProgress(g))),
            f.style.setProperty('--progress', c ? c + '' : '');
          let p = 0.5 * ((u.thumbWidth || 0) - a);
          (h += r),
            (h += p),
            c && (h -= c * (p + o)),
            f.style.setProperty('--shift', h - r + ''),
            (h += p),
            c && (h -= c * (p + o)),
            (h -= r),
            0 === g && (d = o * c);
        }
        s &&
          (s.style.setProperty('--left', d + ''),
          s.style.setProperty('--width', h + d + r + o * c + '')),
          this.shouldCenter && this.centerModern();
      }
      buildClassic() {
        let {container: t, track: e} = this,
          i = this.getSlides();
        if (!t || !e || !i) return;
        let s = new this.instance.constructor(
          t,
          n(
            {
              track: e,
              infinite: !1,
              center: !0,
              fill: !0,
              dragFree: !0,
              slidesPerPage: 1,
              transition: !1,
              Dots: !1,
              Navigation: !1,
              Sync: {},
              classes: {
                container: 'f-thumbs',
                viewport: 'f-thumbs__viewport',
                track: 'f-thumbs__track',
                slide: 'f-thumbs__slide',
              },
            },
            this.option('Carousel') || {},
            {Sync: {target: this.instance}, slides: i}
          )
        );
        (this.carousel = s),
          (this.track = e),
          s.on('ready', () => {
            this.emit('ready');
          });
      }
      buildModern() {
        if ('modern' !== this.type) return;
        let {container: t, track: e, instance: i} = this,
          s = this.option('thumbTpl') || '';
        if (!t || !e || !s) return;
        for (let n of (a(t, 'is-horizontal'), this.updateModern(), i.slides || [])) {
          let o = document.createElement('div');
          if ((a(o, this.cn('slide')), n.type)) {
            let l = `for-${n.type}`;
            ['video', 'youtube', 'vimeo', 'html5video'].includes(n.type) && (l += ' for-video'),
              a(o, l);
          }
          o.appendChild(r(this.formatThumb(n, s))),
            (n.thumbSlideEl = o),
            e.appendChild(o),
            this.resizeModernSlide(n);
        }
        let h = new i.constructor.Panzoom(t, {
          content: e,
          lockAxis: 'x',
          zoom: !1,
          panOnlyZoomed: !1,
          bounds: () => {
            let t = 0,
              e = 0,
              s = i.slides[0],
              n = i.slides[i.slides.length - 1],
              r = i.slides[i.page];
            return (
              s &&
                n &&
                r &&
                ((e = -1 * this.getModernThumbPos(0)),
                0 !== i.page && (e += 0.5 * (s.thumbWidth || 0)),
                (t = -1 * this.getModernThumbPos(i.slides.length - 1)),
                i.page !== i.slides.length - 1 &&
                  (t += (n.thumbWidth || 0) - (r.thumbWidth || 0) - 0.5 * (n.thumbWidth || 0))),
              {x: {min: t, max: e}, y: {min: 0, max: 0}}
            );
          },
        });
        h.on('touchStart', (t, e) => {
          this.shouldCenter = !1;
        }),
          h.on('click', (t, e) => this.onClickModern(e)),
          h.on('ready', () => {
            this.centerModern(), this.emit('ready');
          }),
          h.on(['afterTransform', 'refresh'], (t) => {
            this.lazyLoadModern();
          }),
          (this.panzoom = h),
          this.refreshModern();
      }
      updateModern() {
        if ('modern' !== this.type) return;
        let {container: t} = this;
        t &&
          ((this.thumbGap = parseFloat(getComputedStyle(t).getPropertyValue('--f-thumb-gap')) || 0),
          (this.thumbExtraGap =
            parseFloat(getComputedStyle(t).getPropertyValue('--f-thumb-extra-gap')) || 0),
          (this.thumbWidth =
            parseFloat(getComputedStyle(t).getPropertyValue('--f-thumb-width')) || 40),
          (this.thumbClipWidth =
            parseFloat(getComputedStyle(t).getPropertyValue('--f-thumb-clip-width')) || 40),
          (this.thumbHeight =
            parseFloat(getComputedStyle(t).getPropertyValue('--f-thumb-height')) || 40));
      }
      refreshModern() {
        var t;
        if ('modern' === this.type) {
          for (let e of (this.updateModern(), this.instance.slides || []))
            this.resizeModernSlide(e);
          this.onTransformM(),
            null === (t = this.panzoom) || void 0 === t || t.updateMetrics(!0),
            this.centerModern(0);
        }
      }
      centerModern(t) {
        let i = this.instance,
          {container: s, panzoom: n} = this;
        if (!s || !n || n.state === e.Init) return;
        let r = i.page,
          o = this.getModernThumbPos(r),
          a = o;
        for (let l = i.page - 3; l < i.page + 3; l++) {
          if (l < 0 || l > i.pages.length - 1 || l === i.page) continue;
          let h = 1 - Math.abs(i.getProgress(l));
          h > 0 && h < 1 && (a += h * (this.getModernThumbPos(l) - o));
        }
        let c = 100;
        void 0 === t &&
          ((t = 0.2),
          i.inTransition.size > 0 && (t = 0.12),
          Math.abs(-1 * n.current.e - a) > n.containerRect.width && ((t = 0.5), (c = 0))),
          (n.options.maxVelocity = c),
          n.applyChange({panX: u(-1 * a - n.target.e, 1e3), friction: null === i.prevPage ? 0 : t});
      }
      lazyLoadModern() {
        let {instance: t, panzoom: i} = this;
        if (!i) return;
        let s = -1 * i.current.e || 0,
          n = this.getModernThumbPos(t.page);
        if (i.state !== e.Init || 0 === n)
          for (let o of t.slides || []) {
            let l = o.thumbSlideEl;
            if (!l) continue;
            let h = l.querySelector('img[data-lazy-src]'),
              c = o.index,
              d = this.getModernThumbPos(c),
              u = s - 0.5 * i.containerRect.innerWidth,
              g = u + i.containerRect.innerWidth;
            if (!h || d < u || d > g) continue;
            let f = h.dataset.lazySrc;
            if (!f || !f.length || (delete h.dataset.lazySrc, (h.src = f), h.complete)) continue;
            a(l, this.cn('isLoading'));
            let p = r(
              '<div class="f-spinner"><svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="20"></circle><circle cx="25" cy="25" r="20"></circle></svg></div>'
            );
            l.appendChild(p),
              h.addEventListener(
                'load',
                () => {
                  l.offsetParent && (l.classList.remove(this.cn('isLoading')), p.remove());
                },
                !1
              );
          }
      }
      resizeModernSlide(t) {
        if ('modern' !== this.type || !t.thumbSlideEl) return;
        let e =
          t.thumbClipWidth && t.thumbHeight
            ? Math.round(this.thumbHeight * (t.thumbClipWidth / t.thumbHeight))
            : this.thumbWidth;
        t.thumbWidth = e;
      }
      getModernThumbPos(t) {
        let e = this.instance.slides[t],
          i = this.panzoom;
        if (!i || !i.contentRect.fitWidth) return 0;
        let s = i.containerRect.innerWidth,
          n = i.contentRect.width;
        2 === this.instance.slides.length && ((t -= 1), (n = 2 * this.thumbClipWidth));
        let r =
          t * (this.thumbClipWidth + this.thumbGap) +
          this.thumbExtraGap +
          0.5 * (e.thumbWidth || 0);
        return u((r -= n > s ? 0.5 * s : 0.5 * n) || 0, 1);
      }
      build() {
        let e = this.instance,
          i = e.container,
          s = this.option('minCount') || 0;
        if (s) {
          let n = 0;
          for (let r of e.slides || []) r.thumbSrc && n++;
          if (n < s) return this.cleanup(), void (this.state = t.States.Disabled);
        }
        let o = this.option('type');
        if (0 > ['modern', 'classic'].indexOf(o)) return void (this.state = t.States.Disabled);
        this.type = o;
        let l = document.createElement('div');
        a(l, this.cn('container')), a(l, `is-${o}`);
        let h = this.option('parentEl');
        h ? h.appendChild(l) : i.after(l), (this.container = l), a(i, this.cn('hasThumbs'));
        let c = document.createElement('div');
        a(c, this.cn('track')),
          l.appendChild(c),
          (this.track = c),
          'classic' === o ? this.buildClassic() : this.buildModern(),
          (this.state = t.States.Ready),
          l.addEventListener('click', (t) => {
            setTimeout(() => {
              var t;
              null ===
                (t = null == l ? void 0 : l.querySelector(`[data-carousel-index="${e.page}"]`)) ||
                void 0 === t ||
                t.focus();
            }, 100);
          });
      }
      cleanup() {
        var e, i;
        this.carousel && this.carousel.destroy(),
          (this.carousel = null),
          this.panzoom && this.panzoom.destroy(),
          (this.panzoom = null),
          this.container && this.container.remove(),
          (this.container = null),
          (this.track = null),
          (this.state = t.States.Init),
          (e = this.instance.container),
          (i = this.cn('hasThumbs')),
          e &&
            o(i).forEach((t) => {
              e.classList.remove(t);
            });
      }
      attach() {
        this.instance.on('initSlide', this.onInitSlide),
          this.instance.on('initSlides', this.onInitSlides),
          this.instance.on('Panzoom.afterTransform', this.onTransformM),
          this.instance.on('Panzoom.refresh', this.onRefreshM),
          this.instance.on('change', this.onChangeM);
      }
      detach() {
        this.instance.off('initSlide', this.onInitSlide),
          this.instance.off('initSlides', this.onInitSlides),
          this.instance.off('Panzoom.afterTransform', this.onTransformM),
          this.instance.off('Panzoom.refresh', this.onRefreshM),
          this.instance.off('change', this.onChangeM),
          this.cleanup();
      }
    }
    Object.defineProperty(f, 'defaults', {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: g,
    }),
      (t.Thumbs = f),
      (t.defaultOptions = g);
  });
